export default {
    zh: {
        // SEO Meta
        pageTitle: 'GPT Image 1.5 AI 图像生成器 - 高级 DALL-E 3 替代方案',
        pageDescription:
            '作为 OpenAI DALL·E 3 模型的强大升级，GPT Image 1.5 图像生成模型能够更精准地理解您的复杂创意，并通过流畅的对话式交互，直接在聊天中完成图像的创建与修改。来 WeryAI 立即免费体验最新的 GPT Image 1.5 图像生成模型。',
        pageKeywords:
            'GPT Image 1.5, OpenAI, AI 图像生成, AI 绘画, 人工智能, 图像编辑, DALL-E 替代方案, 对话式 AI',

        // Open Graph
        ogTitle: 'GPT Image 1.5 AI 图像生成器 - 高级 DALL-E 3 替代方案',
        ogDescription:
            '作为 OpenAI DALL·E 3 模型的强大升级，GPT Image 1.5 图像生成模型能够通过流畅的对话式交互精准理解您的创意。',

        // Twitter Card
        twitterTitle: 'GPT Image 1.5 AI 图像生成器 - 高级 DALL-E 3 替代方案',
        twitterDescription:
            '作为 OpenAI DALL·E 3 的强大升级，GPT Image 1.5 通过对话式交互精准理解您的复杂创意。免费试用！',

        // Generator Section
        generatorTitle: 'GPT Image 1.5 图像生成器',
        generatorSubtitle:
            'WeryAI 现已深度集成GPT Image 1.5模型，GPT Image 1.5 是 OpenAI 最新发布的旗舰级图像生成模型，也是首款以 "GPT" 命名的视觉模型，标志着 DALL-E 时代的正式升级。该模型于 2025 年 12 月发布，旨在超越单纯的“文本到像素”匹配，转而利用 GPT-5 级别的推理引擎来理解物理规律、因果关系和复杂的文化语境。GPT Image 1.5 不仅生成速度比前代快 4 倍，更引入了革命性的“对话式编辑”功能，允许用户像修改文档一样修改图像细节，同时完美解决了 AI 生成文字乱码的历史难题。快来 WeryAI 免费体验 GPT Image 1.5，感受“不仅是画图，更是懂你”的智能创作体验！',

        // Core Features Section
        coreFeaturesTitle: 'GPT Image 1.5  核心功能特性',
        coreFeaturesSubtitle:
            '探索 GPT Image 1.5 AI 图像生成器的核心功能，开启革命性的 AI 图像创作之旅',

        // Features
        highFidelityTitle: '世界逻辑推理',
        highFidelityDesc:
            '与传统模型仅通过关键词拼接画面不同，GPT Image 1.5 理解现实世界的物理规则和逻辑。它能根据简略的提示词推断出正确的光影反射、物体重力状态以及特定历史时期的准确细节（如“1969年的音乐节”会自动匹配当时的服装和氛围）。',
        highFidelityAlt: '世界逻辑推理示例',

        multipleStylesTitle: '精准自然语言编辑',
        multipleStylesDesc:
            '支持通过自然语言指令对已生成的图像进行局部修改，而无需复杂的蒙版操作。你可以直接说“把桌上的咖啡换成一杯冒热气的绿茶”，模型会精准替换物体并自动调整周围的光影和倒影，保持画面其余部分完全不变。',
        multipleStylesAlt: '精准自然语言编辑示例',

        preciseTextTitle: '完美排版与文本渲染',
        preciseTextDesc:
            '彻底解决了 AI 生成文字的拼写错误和乱码问题。GPT Image 1.5 能够生成清晰、样式多变且拼写完全正确的长文本，非常适合制作海报、书籍封面、UI 界面设计图以及包含图表的信息图。',
        preciseTextAlt: '完美排版与文本渲染示例',

        interactiveEditingTitle: '角色与风格一致性',
        interactiveEditingDesc:
            '在连续生成多张图片时，模型能够“记住”特定的角色特征（如发型、衣着、面部特征）或特定的艺术风格。这使得创作者可以轻松制作连环画、故事板或品牌一致的营销素材。',
        interactiveEditingAlt: '角色与风格一致性示例',

        // 未翻译
        // How to Use Section
        howToUseTitle: '如何在 WeryAI 上使用 GPT Image 1.5',
        howToUseSubtitle: '简单三步，开始创作',

        step1Title: '选择模型',
        step1Description: '在 AI 图像模型中选择 GPT Image 1.5 模型',

        step2Title: '输入内容',
        step2Description: '输入提示词或上传参考图像',

        step3Title: '生成图像',
        step3Description: '点击生成按钮，等待并下载您的图像',

        // YouTube Videos Section
        youtubeTitle: '关于 GPT Image 1.5 图像模型的 YouTube 视频',

        // X Posts Section
        xPostsTitle: '关于 GPT Image 1.5 图像模型的 X 帖子',

        // Explore Other Models Section
        exploreModelsTitle: '在 WeryAI 上探索其他 AI 图像模型',
        model1Title: 'Google Nano Banana Pro',
        model2Title: 'Seedream 4.5',
        model3Title: 'Qwen Image',
        model4Title: 'Dreamina 4.0',

        // FAQ Section
        faqTitle: '常见问题解答',
        faq1Question: 'GPT Image 1.5 和 DALL-E 3 有什么区别？',
        faq1Answer:
            'GPT Image 1.5 是 DALL-E 3 的继任者。主要区别在于它拥有“世界理解能力”，生成的逻辑性更强；同时支持精准的局部编辑和完美的文字生成，速度也快了 4 倍。',

        faq2Question: '它能生成准确的文字吗？',
        faq2Answer:
            '是的，这是 GPT Image 1.5 的一大卖点。无论是英文标题、标语还是代码片段，它都能以极高的准确率渲染出来，基本告别了以往的“AI 火星文”。',

        faq3Question: '在 WeryAI 上使用需要付费吗？',
        faq3Answer:
            '是的。WeryAI 提供免费试用额度。由于 GPT Image 1.5 是高性能模型，生成高清图或使用多轮编辑功能可能会消耗较多积分，建议重度用户升级 Pro 计划。',

        faq4Question: '我可以上传自己的图片进行编辑吗？',
        faq4Answer:
            '可以。您可以使用“图生图”或“编辑”模式，上传现有照片，然后通过文字指令让 GPT Image 1.5 对其进行修改（如换装、换背景）。',

        faq5Question: '它的推理能力体现在哪里？',
        faq5Answer:
            '体现在对隐含信息的理解上。例如，你只需输入“一个 80 年代的极客房间”，模型会自动补充 CRT 显示器、复古海报、乱糟糟的电缆等符合那个时代的细节，而无需你逐一列举。',

        faq6Question: '商业版权归谁所有？',
        faq6Answer:
            '根据 OpenAI 和 WeryAI 的政策，您使用 GPT Image 1.5 生成的图像归您所有，您可以将其用于商业用途（如广告、商品包装等）。',

        // CTA Section
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 GPT Image 1.5，将您的创意转化为精彩图像',
        ctaButton: '立即体验 GPT Image 1.5',
        ctaDisclaimer: '无须信用卡，注册即可使用',
    },
    en: {
        // SEO Meta
        pageTitle:
            'GPT Image 1.5 AI Image Generator - Advanced DALL·E 3 Alternative',
        pageDescription:
            'As a powerful upgrade to OpenAI’s DALL·E 3, GPT Image 1.5 understands complex ideas more precisely and lets you create and edit images directly in chat through smooth, conversational interactions. Try the latest GPT Image 1.5 on WeryAI for free today.',
        pageKeywords:
            'GPT Image 1.5, OpenAI, AI image generator, AI art, artificial intelligence, image editing, DALL·E alternative, conversational AI',

        // Open Graph
        ogTitle:
            'GPT Image 1.5 AI Image Generator - Advanced DALL·E 3 Alternative',
        ogDescription:
            'A powerful upgrade to OpenAI’s DALL·E 3, GPT Image 1.5 precisely understands your ideas through natural, conversational interaction.',

        // Twitter Card
        twitterTitle:
            'GPT Image 1.5 AI Image Generator - Advanced DALL·E 3 Alternative',
        twitterDescription:
            'A major upgrade to OpenAI’s DALL·E 3 — GPT Image 1.5 understands complex ideas via chat-based editing. Try it free!',

        // Generator Section
        generatorTitle: 'GPT Image 1.5 Image Generator',
        generatorSubtitle:
            'WeryAI now deeply integrates the GPT Image 1.5 model, GPT Image 1.5 is OpenAI’s newest flagship image generation model and the first vision model branded with “GPT”, marking a definitive step beyond the DALL·E era. Released in December 2025, it moves past simple “text-to-pixel” matching and instead leverages GPT-5-level reasoning to understand physics, causality, and nuanced cultural context. GPT Image 1.5 is up to 4× faster than the previous generation and introduces revolutionary “conversational editing”, letting you refine image details like editing a document—while finally solving the long-standing problem of garbled AI-generated text. Try GPT Image 1.5 on WeryAI for free and experience an AI creator that doesn’t just draw—it understands you.',

        // Core Features Section
        coreFeaturesTitle: 'GPT Image 1.5 Core Features',
        coreFeaturesSubtitle:
            'Explore the core capabilities of the GPT Image 1.5 AI image generator and start a revolutionary creative journey',

        // Features
        highFidelityTitle: 'World-Logic Reasoning',
        highFidelityDesc:
            'Unlike traditional models that stitch scenes together from keywords, GPT Image 1.5 understands real-world physics and logic. From short prompts, it can infer correct lighting and reflections, gravity and object states, and historically accurate details (e.g., “a 1969 music festival” will match period outfits and atmosphere).',
        highFidelityAlt: 'World-logic reasoning example',

        multipleStylesTitle: 'Precise Natural-Language Editing',
        multipleStylesDesc:
            'Edit parts of an existing image with simple instructions—no complex masking required. Say “replace the coffee on the table with a steaming cup of green tea”, and the model will swap the object and automatically adjust surrounding light and reflections while keeping everything else unchanged.',
        multipleStylesAlt: 'Precise natural-language editing example',

        preciseTextTitle: 'Perfect Layout & Text Rendering',
        preciseTextDesc:
            'Say goodbye to misspellings and garbled text in AI images. GPT Image 1.5 can render long text clearly, in varied styles, with accurate spelling—ideal for posters, book covers, UI mockups, and infographic-style visuals with charts.',
        preciseTextAlt: 'Perfect layout and text rendering example',

        interactiveEditingTitle: 'Character & Style Consistency',
        interactiveEditingDesc:
            'When generating a series of images, the model can “remember” specific character traits (hair, outfits, facial features) or a particular art style. This makes it easy to create comics, storyboards, or brand-consistent marketing assets.',
        interactiveEditingAlt: 'Character and style consistency example',

        // How to Use Section
        howToUseTitle: 'How to Use GPT Image 1.5 on WeryAI',
        howToUseSubtitle: 'Start creating in three simple steps',

        step1Title: 'Choose the model',
        step1Description: 'Select the GPT Image 1.5 model in AI image models',

        step2Title: 'Enter content',
        step2Description: 'Type a prompt or upload a reference image',

        step3Title: 'Generate images',
        step3Description:
            'Click the generate button, then wait and download your images',

        // YouTube Videos Section
        youtubeTitle: 'YouTube videos about the GPT Image 1.5 image model',

        // X Posts Section
        xPostsTitle: 'X posts about the GPT Image 1.5 image model',

        // Explore Other Models Section
        exploreModelsTitle: 'Explore other AI image models on WeryAI',
        model1Title: 'Google Nano Banana Pro',
        model2Title: 'Seedream 4.5',
        model3Title: 'Qwen Image',
        model4Title: 'Dreamina 4.0',

        // FAQ Section
        faqTitle: 'Frequently Asked Questions',
        faq1Question:
            'What’s the difference between GPT Image 1.5 and DALL·E 3?',
        faq1Answer:
            'GPT Image 1.5 is the successor to DALL·E 3. The key differences are its stronger “world understanding” for more logical outputs, precise local editing, and reliable text rendering—plus it’s up to 4× faster.',

        faq2Question: 'Can it generate accurate text?',
        faq2Answer:
            'Yes—this is a major highlight of GPT Image 1.5. Whether it’s English titles, slogans, or code snippets, it renders text with very high accuracy, largely eliminating the old “AI gibberish”.',

        faq3Question: 'Do I need to pay to use it on WeryAI?',
        faq3Answer:
            'Yes. WeryAI offers a free trial quota. Since GPT Image 1.5 is a high-performance model, generating HD images or using multi-step edits may consume more credits. Heavy users may want to upgrade to the Pro plan.',

        faq4Question: 'Can I upload my own images to edit?',
        faq4Answer:
            'Yes. You can use “image-to-image” or “edit” mode to upload an existing photo, then use text instructions to have GPT Image 1.5 modify it (e.g., change outfits or backgrounds).',

        faq5Question: 'Where does its reasoning show up?',
        faq5Answer:
            'In how it understands implied details. For example, if you type “a geek room from the ’80s”, the model will automatically add era-appropriate details like a CRT monitor, retro posters, and messy cables—without you listing them one by one.',

        faq6Question: 'Who owns the commercial rights?',
        faq6Answer:
            'According to OpenAI and WeryAI policies, the images you generate with GPT Image 1.5 belong to you, and you can use them commercially (e.g., ads, product packaging).',

        // CTA Section
        ctaTitle: 'Ready to start creating?',
        ctaDescription:
            'Try GPT Image 1.5 now and turn your ideas into stunning images',
        ctaButton: 'Try GPT Image 1.5 now',
        ctaDisclaimer: 'No credit card required — sign up to get started',
    },
    ja: {
        // SEO Meta
        pageTitle: 'GPT Image 1.5 AI画像生成 - 高性能DALL·E 3代替',
        pageDescription:
            'OpenAIのDALL·E 3を強化したGPT Image 1.5は、複雑なアイデアもより正確に理解し、会話形式でチャット上から画像の生成・編集まで完結できます。WeryAIで最新のGPT Image 1.5を今すぐ無料で体験しましょう。',
        pageKeywords:
            'GPT Image 1.5, OpenAI, AI画像生成, AIアート, 人工知能, 画像編集, DALL·E代替, 会話型AI',

        // Open Graph
        ogTitle: 'GPT Image 1.5 AI画像生成 - 高性能DALL·E 3代替',
        ogDescription:
            'OpenAIのDALL·E 3を強化したGPT Image 1.5は、自然な会話であなたのアイデアを正確に理解します。',

        // Twitter Card
        twitterTitle: 'GPT Image 1.5 AI画像生成 - 高性能DALL·E 3代替',
        twitterDescription:
            'OpenAIのDALL·E 3を大幅強化。GPT Image 1.5の会話型編集で複雑なアイデアも思い通りに。無料で試そう！',

        // Generator Section
        generatorTitle: 'GPT Image 1.5 画像生成',
        generatorSubtitle:
            'WeryAI はGPT Image 1.5モデルを深く統合し、GPT Image 1.5はOpenAIの最新フラッグシップ画像生成モデルで、初めて「GPT」ブランドを冠したビジョンモデルです。DALL·E時代からの本格的なアップグレードを象徴します。2025年12月に公開され、単なる「テキスト→ピクセル」の一致を超え、GPT-5級の推論で物理法則・因果関係・文化的文脈まで理解します。従来比最大4倍の高速生成に加え、文書を直すように画像を直せる革新的な「会話型編集」を搭載。さらに、AI生成テキストの誤字・文字化け問題も解決しました。WeryAIでGPT Image 1.5を無料体験し、“描くだけじゃなく、わかってくれる”創作体験を。',

        // Core Features Section
        coreFeaturesTitle: 'GPT Image 1.5 コア機能',
        coreFeaturesSubtitle:
            'GPT Image 1.5 AI画像生成の主要機能を探索し、革新的なクリエイティブ体験を始めましょう',

        // Features
        highFidelityTitle: '世界の論理推論',
        highFidelityDesc:
            'キーワードの寄せ集めで画面を作る従来モデルと異なり、GPT Image 1.5は現実世界の物理法則と論理を理解します。短いプロンプトから、光と反射、重力による物体の状態、さらには特定の時代の正確なディテールまで推定（例：「1969年の音楽フェス」なら当時の服装や雰囲気を自動で再現）。',
        highFidelityAlt: '世界の論理推論の例',

        multipleStylesTitle: '自然言語での精密編集',
        multipleStylesDesc:
            '複雑なマスク操作なしで、自然言語の指示だけで部分編集が可能です。「テーブルのコーヒーを湯気の立つ緑茶に替えて」と言えば、対象物を置き換え、周囲の光や反射も自動調整し、他の部分はそのまま保ちます。',
        multipleStylesAlt: '自然言語での精密編集の例',

        preciseTextTitle: '美しいレイアウトと文字描画',
        preciseTextDesc:
            'AI画像の誤字や文字化けを根本的に解決。GPT Image 1.5は長文でもクリアに、スタイル多彩に、綴りも正確に描画できます。ポスター、書籍カバー、UIモック、図表入りインフォグラフィックに最適です。',
        preciseTextAlt: '美しいレイアウトと文字描画の例',

        interactiveEditingTitle: 'キャラクター/スタイルの一貫性',
        interactiveEditingDesc:
            '複数枚を連続生成しても、髪型・服装・顔立ちなどの特徴や特定のアートスタイルを「記憶」できます。マンガ、ストーリーボード、ブランド統一のマーケ素材制作に便利です。',
        interactiveEditingAlt: 'キャラクター/スタイル一貫性の例',

        // How to Use Section
        howToUseTitle: 'WeryAIでGPT Image 1.5を使う方法',
        howToUseSubtitle: '簡単3ステップで創作を開始',

        step1Title: 'モデルを選ぶ',
        step1Description: 'AI画像モデルからGPT Image 1.5を選択',

        step2Title: '内容を入力',
        step2Description: 'プロンプトを入力するか参考画像をアップロード',

        step3Title: '画像を生成',
        step3Description:
            '生成ボタンをクリックして、完了後に画像をダウンロード',

        // YouTube Videos Section
        youtubeTitle: 'GPT Image 1.5 画像モデルに関するYouTube動画',

        // X Posts Section
        xPostsTitle: 'GPT Image 1.5 画像モデルに関するX投稿',

        // Explore Other Models Section
        exploreModelsTitle: 'WeryAIで他のAI画像モデルも探索',
        model1Title: 'Google Nano Banana Pro',
        model2Title: 'Seedream 4.5',
        model3Title: 'Qwen Image',
        model4Title: 'Dreamina 4.0',

        // FAQ Section
        faqTitle: 'よくある質問',
        faq1Question: 'GPT Image 1.5とDALL·E 3の違いは？',
        faq1Answer:
            'GPT Image 1.5はDALL·E 3の後継モデルです。最大の違いは「世界理解」による高い整合性、精密な部分編集、そして正確な文字生成です。さらに生成速度も最大4倍に向上しています。',

        faq2Question: '正確な文字を生成できますか？',
        faq2Answer:
            'はい。これはGPT Image 1.5の大きな強みです。英語の見出しやキャッチコピー、コード断片まで高精度に描画でき、従来の“AI文字化け”を大幅に解消します。',

        faq3Question: 'WeryAIで使うには有料ですか？',
        faq3Answer:
            'はい。WeryAIには無料トライアル枠がありますが、GPT Image 1.5は高性能モデルのため、高解像度生成や多段階の編集はクレジット消費が大きくなる場合があります。ヘビーユーザーはProプランの利用をおすすめします。',

        faq4Question: '自分の画像をアップロードして編集できますか？',
        faq4Answer:
            'できます。「画像→画像」または「編集」モードで写真をアップロードし、テキスト指示でGPT Image 1.5に変更（着せ替え、背景変更など）を行えます。',

        faq5Question: '推論力はどこに表れますか？',
        faq5Answer:
            '暗黙の情報を読み取る点です。例えば「80年代のギーク部屋」と入力するだけで、CRTモニターやレトロなポスター、散らかったケーブルなど時代に合う要素を自動で補完します。',

        faq6Question: '商用利用の権利は誰にありますか？',
        faq6Answer:
            'OpenAIおよびWeryAIのポリシーに基づき、GPT Image 1.5で生成した画像の権利はあなたに帰属し、広告や商品パッケージなど商用利用が可能です。',

        // CTA Section
        ctaTitle: '創作を始める準備はできましたか？',
        ctaDescription:
            '今すぐGPT Image 1.5を体験して、アイデアを魅力的な画像に変えましょう',
        ctaButton: '今すぐGPT Image 1.5を体験',
        ctaDisclaimer: 'クレジットカード不要。登録するだけで利用できます',
    },
    ko: {
        // SEO Meta
        pageTitle: 'GPT Image 1.5 AI 이미지 생성기 - 고급 DALL·E 3 대안',
        pageDescription:
            'OpenAI DALL·E 3의 강력한 업그레이드인 GPT Image 1.5는 복잡한 아이디어를 더 정확히 이해하고, 매끄러운 대화형 인터랙션으로 채팅에서 바로 이미지 생성과 편집을 완료합니다. WeryAI에서 최신 GPT Image 1.5를 지금 무료로 체험해 보세요.',
        pageKeywords:
            'GPT Image 1.5, OpenAI, AI 이미지 생성, AI 아트, 인공지능, 이미지 편집, DALL·E 대안, 대화형 AI',

        // Open Graph
        ogTitle: 'GPT Image 1.5 AI 이미지 생성기 - 고급 DALL·E 3 대안',
        ogDescription:
            'OpenAI DALL·E 3의 강력한 업그레이드인 GPT Image 1.5는 자연스러운 대화로 당신의 아이디어를 정밀하게 이해합니다.',

        // Twitter Card
        twitterTitle: 'GPT Image 1.5 AI 이미지 생성기 - 고급 DALL·E 3 대안',
        twitterDescription:
            'OpenAI DALL·E 3의 강력한 업그레이드. GPT Image 1.5의 대화형 편집으로 복잡한 아이디어도 정확하게. 무료로 사용해 보세요!',

        // Generator Section
        generatorTitle: 'GPT Image 1.5 이미지 생성기',
        generatorSubtitle:
            'WeryAI는 이제 GPT Image 1.5 모델을 심층 통합하여, GPT Image 1.5는 OpenAI가 공개한 최신 플래그십 이미지 생성 모델이자, 최초로 “GPT” 이름을 단 비전 모델로서 DALL·E 시대의 본격적인 업그레이드를 상징합니다. 2025년 12월 출시되었으며, 단순한 “텍스트-픽셀” 매칭을 넘어 GPT-5급 추론으로 물리 법칙, 인과 관계, 복잡한 문화적 맥락까지 이해합니다. 이전 세대 대비 최대 4배 빠른 생성 속도와 함께, 문서를 수정하듯 이미지 디테일을 바꿀 수 있는 혁신적인 “대화형 편집”을 도입했고, AI 텍스트의 오타/깨짐 문제도 해결했습니다. WeryAI에서 GPT Image 1.5를 무료로 체험하고, “그리는 것”을 넘어 “이해하는” 창작 경험을 느껴보세요.',

        // Core Features Section
        coreFeaturesTitle: 'GPT Image 1.5 핵심 기능',
        coreFeaturesSubtitle:
            'GPT Image 1.5 AI 이미지 생성기의 핵심 기능을 살펴보고 혁신적인 창작 여정을 시작하세요',

        // Features
        highFidelityTitle: '세계 논리 추론',
        highFidelityDesc:
            '키워드를 이어 붙여 장면을 만드는 기존 모델과 달리, GPT Image 1.5는 현실 세계의 물리 규칙과 논리를 이해합니다. 짧은 프롬프트만으로도 올바른 빛/반사, 중력에 따른 물체 상태, 특정 시대의 정확한 디테일까지 추론합니다(예: “1969년 음악 페스티벌”은 당시 복장과 분위기를 자동으로 반영).',
        highFidelityAlt: '세계 논리 추론 예시',

        multipleStylesTitle: '정밀 자연어 편집',
        multipleStylesDesc:
            '복잡한 마스크 작업 없이도 자연어 지시만으로 부분 편집이 가능합니다. “테이블 위 커피를 김이 나는 녹차로 바꿔줘”라고 말하면, 물체를 정확히 교체하고 주변 빛과 반사까지 자동으로 조정하면서 나머지 영역은 그대로 유지합니다.',
        multipleStylesAlt: '정밀 자연어 편집 예시',

        preciseTextTitle: '완벽한 레이아웃 & 텍스트 렌더링',
        preciseTextDesc:
            'AI 이미지의 오탈자와 글자 깨짐 문제를 해결했습니다. GPT Image 1.5는 긴 텍스트도 선명하게, 다양한 스타일로, 철자까지 정확하게 렌더링할 수 있어 포스터, 책 표지, UI 시안, 차트가 포함된 인포그래픽 제작에 적합합니다.',
        preciseTextAlt: '완벽한 레이아웃과 텍스트 렌더링 예시',

        interactiveEditingTitle: '캐릭터 & 스타일 일관성',
        interactiveEditingDesc:
            '여러 장을 연속 생성할 때도 특정 캐릭터 특징(헤어스타일, 의상, 얼굴 특징)이나 특정 아트 스타일을 “기억”할 수 있습니다. 만화, 스토리보드, 브랜드 일관성이 필요한 마케팅 소재를 쉽게 제작할 수 있습니다.',
        interactiveEditingAlt: '캐릭터 및 스타일 일관성 예시',

        // How to Use Section
        howToUseTitle: 'WeryAI에서 GPT Image 1.5 사용하는 방법',
        howToUseSubtitle: '간단한 3단계로 창작 시작',

        step1Title: '모델 선택',
        step1Description: 'AI 이미지 모델에서 GPT Image 1.5 모델을 선택하세요',

        step2Title: '내용 입력',
        step2Description: '프롬프트를 입력하거나 참고 이미지를 업로드하세요',

        step3Title: '이미지 생성',
        step3Description:
            '생성 버튼을 누른 뒤 완료되면 이미지를 다운로드하세요',

        // YouTube Videos Section
        youtubeTitle: 'GPT Image 1.5 이미지 모델 관련 YouTube 영상',

        // X Posts Section
        xPostsTitle: 'GPT Image 1.5 이미지 모델 관련 X 게시물',

        // Explore Other Models Section
        exploreModelsTitle: 'WeryAI에서 다른 AI 이미지 모델도 살펴보기',
        model1Title: 'Google Nano Banana Pro',
        model2Title: 'Seedream 4.5',
        model3Title: 'Qwen Image',
        model4Title: 'Dreamina 4.0',

        // FAQ Section
        faqTitle: '자주 묻는 질문',
        faq1Question: 'GPT Image 1.5와 DALL·E 3의 차이는 무엇인가요?',
        faq1Answer:
            'GPT Image 1.5는 DALL·E 3의 후속 모델입니다. 핵심 차이는 “세계 이해”로 더 논리적인 결과를 만들고, 정밀한 부분 편집과 정확한 텍스트 생성이 가능하며, 속도도 최대 4배 더 빠르다는 점입니다.',

        faq2Question: '정확한 글자를 생성할 수 있나요?',
        faq2Answer:
            '네. 이는 GPT Image 1.5의 큰 강점입니다. 영어 제목, 슬로건, 코드 조각 등도 매우 높은 정확도로 렌더링하여 예전의 “AI 문자 깨짐”을 크게 줄여줍니다.',

        faq3Question: 'WeryAI에서 사용하려면 유료인가요?',
        faq3Answer:
            '네. WeryAI는 무료 체험 크레딧을 제공합니다. 다만 GPT Image 1.5는 고성능 모델이라 고해상도 생성이나 다단계 편집은 크레딧 소모가 클 수 있어, 헤비 유저는 Pro 플랜 업그레이드를 권장합니다.',

        faq4Question: '내 이미지를 업로드해서 편집할 수 있나요?',
        faq4Answer:
            '가능합니다. “이미지-투-이미지” 또는 “편집” 모드로 사진을 업로드한 뒤, 텍스트 지시로 GPT Image 1.5가 변경(예: 의상 변경, 배경 변경)하도록 할 수 있습니다.',

        faq5Question: '추론 능력은 어디에서 드러나나요?',
        faq5Answer:
            '암묵적인 정보를 이해하는 부분에서 드러납니다. 예를 들어 “80년대 괴짜 방”이라고만 입력해도, CRT 모니터, 레트로 포스터, 어질러진 케이블 같은 시대에 맞는 디테일을 일일이 나열하지 않아도 자동으로 보완합니다.',

        faq6Question: '상업적 저작권은 누구에게 있나요?',
        faq6Answer:
            'OpenAI 및 WeryAI 정책에 따라, GPT Image 1.5로 생성한 이미지는 사용자에게 귀속되며 광고, 상품 패키지 등 상업적 용도로 사용할 수 있습니다.',

        // CTA Section
        ctaTitle: '창작을 시작할 준비가 되셨나요?',
        ctaDescription:
            '지금 GPT Image 1.5를 체험하고 아이디어를 멋진 이미지로 바꿔보세요',
        ctaButton: '지금 GPT Image 1.5 체험하기',
        ctaDisclaimer: '신용카드 필요 없음 — 가입만 하면 바로 사용 가능',
    },
    tw: {

        // SEO Meta
        pageTitle: 'GPT Image 1.5 AI 图像生成器 - 高级 DALL-E 3 替代方案',
        pageDescription:
            '作为 OpenAI DALL·E 3 模型的强大升级，GPT Image 1.5 图像生成模型能够更精准地理解您的复杂创意，并通过流畅的对话式交互，直接在聊天中完成图像的创建与修改。来 WeryAI 立即免费体验最新的 GPT Image 1.5 图像生成模型。',
        pageKeywords:
            'GPT Image 1.5, OpenAI, AI 图像生成, AI 绘画, 人工智能, 图像编辑, DALL-E 替代方案, 对话式 AI',

        // Open Graph
        ogTitle: 'GPT Image 1.5 AI 图像生成器 - 高级 DALL-E 3 替代方案',
        ogDescription:
            '作为 OpenAI DALL·E 3 模型的强大升级，GPT Image 1.5 图像生成模型能够通过流畅的对话式交互精准理解您的创意。',

        // Twitter Card
        twitterTitle: 'GPT Image 1.5 AI 图像生成器 - 高级 DALL-E 3 替代方案',
        twitterDescription:
            '作为 OpenAI DALL·E 3 的强大升级，GPT Image 1.5 通过对话式交互精准理解您的复杂创意。免费试用！',

        // Generator Section
        generatorTitle: 'GPT Image 1.5 图像生成器',
        generatorSubtitle:
            'WeryAI 現已深度整合GPT Image 1.5模型，GPT Image 1.5 是 OpenAI 最新发布的旗舰级图像生成模型，也是首款以 "GPT" 命名的视觉模型，标志着 DALL-E 时代的正式升级。该模型于 2025 年 12 月发布，旨在超越单纯的“文本到像素”匹配，转而利用 GPT-5 级别的推理引擎来理解物理规律、因果关系和复杂的文化语境。GPT Image 1.5 不仅生成速度比前代快 4 倍，更引入了革命性的“对话式编辑”功能，允许用户像修改文档一样修改图像细节，同时完美解决了 AI 生成文字乱码的历史难题。快来 WeryAI 免费体验 GPT Image 1.5，感受“不仅是画图，更是懂你”的智能创作体验！',

        // Core Features Section
        coreFeaturesTitle: 'GPT Image 1.5  核心功能特性',
        coreFeaturesSubtitle:
            '探索 GPT Image 1.5 AI 图像生成器的核心功能，开启革命性的 AI 图像创作之旅',

        // Features
        highFidelityTitle: '世界逻辑推理',
        highFidelityDesc:
            '与传统模型仅通过关键词拼接画面不同，GPT Image 1.5 理解现实世界的物理规则和逻辑。它能根据简略的提示词推断出正确的光影反射、物体重力状态以及特定历史时期的准确细节（如“1969年的音乐节”会自动匹配当时的服装和氛围）。',
        highFidelityAlt: '世界逻辑推理示例',

        multipleStylesTitle: '精准自然语言编辑',
        multipleStylesDesc:
            '支持通过自然语言指令对已生成的图像进行局部修改，而无需复杂的蒙版操作。你可以直接说“把桌上的咖啡换成一杯冒热气的绿茶”，模型会精准替换物体并自动调整周围的光影和倒影，保持画面其余部分完全不变。',
        multipleStylesAlt: '精准自然语言编辑示例',

        preciseTextTitle: '完美排版与文本渲染',
        preciseTextDesc:
            '彻底解决了 AI 生成文字的拼写错误和乱码问题。GPT Image 1.5 能够生成清晰、样式多变且拼写完全正确的长文本，非常适合制作海报、书籍封面、UI 界面设计图以及包含图表的信息图。',
        preciseTextAlt: '完美排版与文本渲染示例',

        interactiveEditingTitle: '角色与风格一致性',
        interactiveEditingDesc:
            '在连续生成多张图片时，模型能够“记住”特定的角色特征（如发型、衣着、面部特征）或特定的艺术风格。这使得创作者可以轻松制作连环画、故事板或品牌一致的营销素材。',
        interactiveEditingAlt: '角色与风格一致性示例',

        // 未翻译
        // How to Use Section
        howToUseTitle: '如何在 WeryAI 上使用 GPT Image 1.5',
        howToUseSubtitle: '简单三步，开始创作',

        step1Title: '选择模型',
        step1Description: '在 AI 图像模型中选择 GPT Image 1.5 模型',

        step2Title: '输入内容',
        step2Description: '输入提示词或上传参考图像',

        step3Title: '生成图像',
        step3Description: '点击生成按钮，等待并下载您的图像',

        // YouTube Videos Section
        youtubeTitle: '关于 GPT Image 1.5 图像模型的 YouTube 视频',

        // X Posts Section
        xPostsTitle: '关于 GPT Image 1.5 图像模型的 X 帖子',

        // Explore Other Models Section
        exploreModelsTitle: '在 WeryAI 上探索其他 AI 图像模型',
        model1Title: 'Google Nano Banana Pro',
        model2Title: 'Seedream 4.5',
        model3Title: 'Qwen Image',
        model4Title: 'Dreamina 4.0',

        // FAQ Section
        faqTitle: '常见问题解答',
        faq1Question: 'GPT Image 1.5 和 DALL-E 3 有什么区别？',
        faq1Answer:
            'GPT Image 1.5 是 DALL-E 3 的继任者。主要区别在于它拥有“世界理解能力”，生成的逻辑性更强；同时支持精准的局部编辑和完美的文字生成，速度也快了 4 倍。',

        faq2Question: '它能生成准确的文字吗？',
        faq2Answer:
            '是的，这是 GPT Image 1.5 的一大卖点。无论是英文标题、标语还是代码片段，它都能以极高的准确率渲染出来，基本告别了以往的“AI 火星文”。',

        faq3Question: '在 WeryAI 上使用需要付费吗？',
        faq3Answer:
            '是的。WeryAI 提供免费试用额度。由于 GPT Image 1.5 是高性能模型，生成高清图或使用多轮编辑功能可能会消耗较多积分，建议重度用户升级 Pro 计划。',

        faq4Question: '我可以上传自己的图片进行编辑吗？',
        faq4Answer:
            '可以。您可以使用“图生图”或“编辑”模式，上传现有照片，然后通过文字指令让 GPT Image 1.5 对其进行修改（如换装、换背景）。',

        faq5Question: '它的推理能力体现在哪里？',
        faq5Answer:
            '体现在对隐含信息的理解上。例如，你只需输入“一个 80 年代的极客房间”，模型会自动补充 CRT 显示器、复古海报、乱糟糟的电缆等符合那个时代的细节，而无需你逐一列举。',

        faq6Question: '商业版权归谁所有？',
        faq6Answer:
            '根据 OpenAI 和 WeryAI 的政策，您使用 GPT Image 1.5 生成的图像归您所有，您可以将其用于商业用途（如广告、商品包装等）。',

        // CTA Section
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 GPT Image 1.5，将您的创意转化为精彩图像',
        ctaButton: '立即体验 GPT Image 1.5',
        ctaDisclaimer: '无须信用卡，注册即可使用',
    },
    pl: {

        // SEO Meta
        pageTitle:
            'GPT Image 1.5 AI Image Generator - Advanced DALL·E 3 Alternative',
        pageDescription:
            'As a powerful upgrade to OpenAI’s DALL·E 3, GPT Image 1.5 understands complex ideas more precisely and lets you create and edit images directly in chat through smooth, conversational interactions. Try the latest GPT Image 1.5 on WeryAI for free today.',
        pageKeywords:
            'GPT Image 1.5, OpenAI, AI image generator, AI art, artificial intelligence, image editing, DALL·E alternative, conversational AI',

        // Open Graph
        ogTitle:
            'GPT Image 1.5 AI Image Generator - Advanced DALL·E 3 Alternative',
        ogDescription:
            'A powerful upgrade to OpenAI’s DALL·E 3, GPT Image 1.5 precisely understands your ideas through natural, conversational interaction.',

        // Twitter Card
        twitterTitle:
            'GPT Image 1.5 AI Image Generator - Advanced DALL·E 3 Alternative',
        twitterDescription:
            'A major upgrade to OpenAI’s DALL·E 3 — GPT Image 1.5 understands complex ideas via chat-based editing. Try it free!',

        // Generator Section
        generatorTitle: 'GPT Image 1.5 Image Generator',
        generatorSubtitle:
            'WeryAI jest teraz głęboko zintegrowane z modelem GPT Image 1.5, GPT Image 1.5 is OpenAI’s newest flagship image generation model and the first vision model branded with “GPT”, marking a definitive step beyond the DALL·E era. Released in December 2025, it moves past simple “text-to-pixel” matching and instead leverages GPT-5-level reasoning to understand physics, causality, and nuanced cultural context. GPT Image 1.5 is up to 4× faster than the previous generation and introduces revolutionary “conversational editing”, letting you refine image details like editing a document—while finally solving the long-standing problem of garbled AI-generated text. Try GPT Image 1.5 on WeryAI for free and experience an AI creator that doesn’t just draw—it understands you.',

        // Core Features Section
        coreFeaturesTitle: 'GPT Image 1.5 Core Features',
        coreFeaturesSubtitle:
            'Explore the core capabilities of the GPT Image 1.5 AI image generator and start a revolutionary creative journey',

        // Features
        highFidelityTitle: 'World-Logic Reasoning',
        highFidelityDesc:
            'Unlike traditional models that stitch scenes together from keywords, GPT Image 1.5 understands real-world physics and logic. From short prompts, it can infer correct lighting and reflections, gravity and object states, and historically accurate details (e.g., “a 1969 music festival” will match period outfits and atmosphere).',
        highFidelityAlt: 'World-logic reasoning example',

        multipleStylesTitle: 'Precise Natural-Language Editing',
        multipleStylesDesc:
            'Edit parts of an existing image with simple instructions—no complex masking required. Say “replace the coffee on the table with a steaming cup of green tea”, and the model will swap the object and automatically adjust surrounding light and reflections while keeping everything else unchanged.',
        multipleStylesAlt: 'Precise natural-language editing example',

        preciseTextTitle: 'Perfect Layout & Text Rendering',
        preciseTextDesc:
            'Say goodbye to misspellings and garbled text in AI images. GPT Image 1.5 can render long text clearly, in varied styles, with accurate spelling—ideal for posters, book covers, UI mockups, and infographic-style visuals with charts.',
        preciseTextAlt: 'Perfect layout and text rendering example',

        interactiveEditingTitle: 'Character & Style Consistency',
        interactiveEditingDesc:
            'When generating a series of images, the model can “remember” specific character traits (hair, outfits, facial features) or a particular art style. This makes it easy to create comics, storyboards, or brand-consistent marketing assets.',
        interactiveEditingAlt: 'Character and style consistency example',

        // How to Use Section
        howToUseTitle: 'How to Use GPT Image 1.5 on WeryAI',
        howToUseSubtitle: 'Start creating in three simple steps',

        step1Title: 'Choose the model',
        step1Description: 'Select the GPT Image 1.5 model in AI image models',

        step2Title: 'Enter content',
        step2Description: 'Type a prompt or upload a reference image',

        step3Title: 'Generate images',
        step3Description:
            'Click the generate button, then wait and download your images',

        // YouTube Videos Section
        youtubeTitle: 'YouTube videos about the GPT Image 1.5 image model',

        // X Posts Section
        xPostsTitle: 'X posts about the GPT Image 1.5 image model',

        // Explore Other Models Section
        exploreModelsTitle: 'Explore other AI image models on WeryAI',
        model1Title: 'Google Nano Banana Pro',
        model2Title: 'Seedream 4.5',
        model3Title: 'Qwen Image',
        model4Title: 'Dreamina 4.0',

        // FAQ Section
        faqTitle: 'Frequently Asked Questions',
        faq1Question:
            'What’s the difference between GPT Image 1.5 and DALL·E 3?',
        faq1Answer:
            'GPT Image 1.5 is the successor to DALL·E 3. The key differences are its stronger “world understanding” for more logical outputs, precise local editing, and reliable text rendering—plus it’s up to 4× faster.',

        faq2Question: 'Can it generate accurate text?',
        faq2Answer:
            'Yes—this is a major highlight of GPT Image 1.5. Whether it’s English titles, slogans, or code snippets, it renders text with very high accuracy, largely eliminating the old “AI gibberish”.',

        faq3Question: 'Do I need to pay to use it on WeryAI?',
        faq3Answer:
            'Yes. WeryAI offers a free trial quota. Since GPT Image 1.5 is a high-performance model, generating HD images or using multi-step edits may consume more credits. Heavy users may want to upgrade to the Pro plan.',

        faq4Question: 'Can I upload my own images to edit?',
        faq4Answer:
            'Yes. You can use “image-to-image” or “edit” mode to upload an existing photo, then use text instructions to have GPT Image 1.5 modify it (e.g., change outfits or backgrounds).',

        faq5Question: 'Where does its reasoning show up?',
        faq5Answer:
            'In how it understands implied details. For example, if you type “a geek room from the ’80s”, the model will automatically add era-appropriate details like a CRT monitor, retro posters, and messy cables—without you listing them one by one.',

        faq6Question: 'Who owns the commercial rights?',
        faq6Answer:
            'According to OpenAI and WeryAI policies, the images you generate with GPT Image 1.5 belong to you, and you can use them commercially (e.g., ads, product packaging).',

        // CTA Section
        ctaTitle: 'Ready to start creating?',
        ctaDescription:
            'Try GPT Image 1.5 now and turn your ideas into stunning images',
        ctaButton: 'Try GPT Image 1.5 now',
        ctaDisclaimer: 'No credit card required — sign up to get started',
    },
    es: {
        // SEO Meta
        pageTitle:
            'Generador de Imágenes con IA GPT Image 1.5 - Alternativa avanzada a DALL·E 3',
        pageDescription:
            'Como una potente evolución de OpenAI DALL·E 3, GPT Image 1.5 entiende ideas complejas con mayor precisión y te permite crear y editar imágenes directamente en el chat con una interacción conversacional fluida. Pruébalo gratis en WeryAI hoy mismo.',
        pageKeywords:
            'GPT Image 1.5, OpenAI, generador de imágenes IA, arte IA, inteligencia artificial, edición de imágenes, alternativa a DALL·E, IA conversacional',

        // Open Graph
        ogTitle:
            'Generador de Imágenes con IA GPT Image 1.5 - Alternativa avanzada a DALL·E 3',
        ogDescription:
            'Una potente evolución de OpenAI DALL·E 3: GPT Image 1.5 entiende tu idea con precisión mediante interacción conversacional.',

        // Twitter Card
        twitterTitle:
            'Generador de Imágenes con IA GPT Image 1.5 - Alternativa avanzada a DALL·E 3',
        twitterDescription:
            'La gran mejora de OpenAI DALL·E 3. GPT Image 1.5 entiende ideas complejas con edición conversacional. ¡Pruébalo gratis!',

        // Generator Section
        generatorTitle: 'Generador de Imágenes GPT Image 1.5',
        generatorSubtitle:
            'WeryAI ahora integra profundamente el modelo GPT Image 1.5, GPT Image 1.5 es el modelo insignia más reciente de OpenAI para generación de imágenes y el primer modelo visual con la marca “GPT”, marcando una actualización definitiva de la era DALL·E. Lanzado en diciembre de 2025, va más allá del simple “texto a píxeles” y aprovecha un razonamiento de nivel GPT-5 para comprender física, causalidad y matices culturales. GPT Image 1.5 no solo genera hasta 4× más rápido que la generación anterior, sino que introduce una revolucionaria “edición conversacional”, permitiéndote ajustar detalles como si editaras un documento, y resolviendo por fin el problema histórico del texto ilegible en imágenes generadas por IA. Prueba GPT Image 1.5 gratis en WeryAI y vive una creación inteligente que no solo dibuja: te entiende.',

        // Core Features Section
        coreFeaturesTitle: 'Funciones clave de GPT Image 1.5',
        coreFeaturesSubtitle:
            'Explora las capacidades principales del generador de imágenes con IA GPT Image 1.5 y empieza una experiencia creativa revolucionaria',

        // Features
        highFidelityTitle: 'Razonamiento con lógica del mundo',
        highFidelityDesc:
            'A diferencia de los modelos tradicionales que ensamblan escenas a partir de palabras clave, GPT Image 1.5 entiende la física y la lógica del mundo real. Con prompts breves, infiere iluminación y reflejos correctos, estados bajo gravedad y detalles históricos precisos (por ejemplo, “festival de música de 1969” ajusta ropa y ambiente de la época).',
        highFidelityAlt: 'Ejemplo de razonamiento con lógica del mundo',

        multipleStylesTitle: 'Edición precisa en lenguaje natural',
        multipleStylesDesc:
            'Edita partes de una imagen con instrucciones simples, sin máscaras complejas. Di “cambia el café de la mesa por una taza de té verde humeante”, y el modelo sustituirá el objeto y ajustará automáticamente luces y reflejos, manteniendo el resto intacto.',
        multipleStylesAlt: 'Ejemplo de edición precisa en lenguaje natural',

        preciseTextTitle: 'Maquetación perfecta y texto legible',
        preciseTextDesc:
            'Adiós a errores ortográficos y texto ilegible. GPT Image 1.5 puede renderizar textos largos con claridad, múltiples estilos y ortografía correcta, ideal para pósteres, portadas de libros, mockups de UI e infografías con gráficos.',
        preciseTextAlt: 'Ejemplo de maquetación perfecta y texto legible',

        interactiveEditingTitle: 'Consistencia de personaje y estilo',
        interactiveEditingDesc:
            'Al generar una serie de imágenes, el modelo puede “recordar” rasgos de un personaje (peinado, ropa, facciones) o un estilo artístico específico. Facilita crear cómics, storyboards o materiales de marketing con coherencia de marca.',
        interactiveEditingAlt: 'Ejemplo de consistencia de personaje y estilo',

        // How to Use Section
        howToUseTitle: 'Cómo usar GPT Image 1.5 en WeryAI',
        howToUseSubtitle: 'Empieza a crear en tres pasos sencillos',

        step1Title: 'Elige el modelo',
        step1Description:
            'Selecciona el modelo GPT Image 1.5 dentro de los modelos de imagen con IA',

        step2Title: 'Introduce el contenido',
        step2Description: 'Escribe un prompt o sube una imagen de referencia',

        step3Title: 'Genera la imagen',
        step3Description:
            'Haz clic en “Generar”, espera y descarga tus imágenes',

        // YouTube Videos Section
        youtubeTitle:
            'Vídeos de YouTube sobre el modelo de imagen GPT Image 1.5',

        // X Posts Section
        xPostsTitle:
            'Publicaciones en X sobre el modelo de imagen GPT Image 1.5',

        // Explore Other Models Section
        exploreModelsTitle: 'Explora otros modelos de imagen con IA en WeryAI',
        model1Title: 'Google Nano Banana Pro',
        model2Title: 'Seedream 4.5',
        model3Title: 'Qwen Image',
        model4Title: 'Dreamina 4.0',

        // FAQ Section
        faqTitle: 'Preguntas frecuentes',
        faq1Question: '¿Cuál es la diferencia entre GPT Image 1.5 y DALL·E 3?',
        faq1Answer:
            'GPT Image 1.5 es el sucesor de DALL·E 3. La principal diferencia es su “comprensión del mundo”, que hace que los resultados sean más coherentes; además permite edición local precisa y generación de texto fiable, y es hasta 4× más rápido.',

        faq2Question: '¿Puede generar texto con precisión?',
        faq2Answer:
            'Sí, es uno de los puntos fuertes de GPT Image 1.5. Ya sean títulos en inglés, eslóganes o fragmentos de código, los renderiza con una precisión muy alta, diciendo adiós al “texto ilegible” típico.',

        faq3Question: '¿Tengo que pagar para usarlo en WeryAI?',
        faq3Answer:
            'Sí. WeryAI ofrece una cuota de prueba gratuita. Como GPT Image 1.5 es un modelo de alto rendimiento, generar imágenes en alta resolución o realizar ediciones en varias rondas puede consumir más créditos. Si lo usas mucho, te conviene el plan Pro.',

        faq4Question: '¿Puedo subir mis propias imágenes para editarlas?',
        faq4Answer:
            'Sí. Puedes usar el modo “imagen a imagen” o “editar”, subir una foto y luego dar instrucciones por texto para que GPT Image 1.5 la modifique (por ejemplo, cambiar ropa o fondo).',

        faq5Question: '¿Dónde se nota su capacidad de razonamiento?',
        faq5Answer:
            'En cómo entiende información implícita. Por ejemplo, si escribes “una habitación geek de los 80”, el modelo añadirá detalles de la época como un monitor CRT, pósters retro y cables desordenados, sin que tengas que enumerarlos uno por uno.',

        faq6Question: '¿Quién posee los derechos comerciales?',
        faq6Answer:
            'Según las políticas de OpenAI y WeryAI, las imágenes que generas con GPT Image 1.5 te pertenecen y puedes usarlas con fines comerciales (por ejemplo, anuncios o empaques de productos).',

        // CTA Section
        ctaTitle: '¿Listo para empezar a crear?',
        ctaDescription:
            'Prueba GPT Image 1.5 ahora y convierte tus ideas en imágenes increíbles',
        ctaButton: 'Probar GPT Image 1.5 ahora',
        ctaDisclaimer:
            'No se requiere tarjeta de crédito: regístrate y empieza',
    },
    fr: {
        // SEO Meta
        pageTitle:
            'Générateur d’images IA GPT Image 1.5 - Alternative avancée à DALL·E 3',
        pageDescription:
            'Puissante évolution d’OpenAI DALL·E 3, GPT Image 1.5 comprend vos idées complexes avec plus de précision et vous permet de créer et modifier des images directement dans le chat via une interaction conversationnelle fluide. Essayez gratuitement GPT Image 1.5 sur WeryAI dès maintenant.',
        pageKeywords:
            'GPT Image 1.5, OpenAI, générateur d’images IA, art IA, intelligence artificielle, édition d’images, alternative à DALL·E, IA conversationnelle',

        // Open Graph
        ogTitle:
            'Générateur d’images IA GPT Image 1.5 - Alternative avancée à DALL·E 3',
        ogDescription:
            'Une puissante évolution d’OpenAI DALL·E 3 : GPT Image 1.5 comprend vos idées avec précision grâce à l’interaction conversationnelle.',

        // Twitter Card
        twitterTitle:
            'Générateur d’images IA GPT Image 1.5 - Alternative avancée à DALL·E 3',
        twitterDescription:
            'La grande mise à niveau de DALL·E 3. GPT Image 1.5 comprend les idées complexes via l’édition conversationnelle. Essai gratuit !',

        // Generator Section
        generatorTitle: 'Générateur d’images GPT Image 1.5',
        generatorSubtitle:
            'WeryAI intègre désormais en profondeur le modèle GPT Image 1.5, GPT Image 1.5 est le tout dernier modèle phare d’OpenAI pour la génération d’images, et le premier modèle visuel portant le nom “GPT”, marquant une mise à niveau majeure de l’ère DALL·E. Publié en décembre 2025, il dépasse le simple “texte → pixels” et s’appuie sur un raisonnement de niveau GPT-5 pour comprendre la physique, la causalité et des contextes culturels complexes. Jusqu’à 4× plus rapide que la génération précédente, GPT Image 1.5 introduit une “édition conversationnelle” révolutionnaire qui permet d’ajuster les détails comme on modifie un document—tout en résolvant enfin le problème historique du texte illisible généré par l’IA. Essayez GPT Image 1.5 gratuitement sur WeryAI et découvrez une création intelligente qui ne se contente pas de dessiner : elle vous comprend.',

        // Core Features Section
        coreFeaturesTitle: 'Fonctionnalités clés de GPT Image 1.5',
        coreFeaturesSubtitle:
            'Découvrez les capacités essentielles du générateur d’images IA GPT Image 1.5 et lancez-vous dans une expérience créative révolutionnaire',

        // Features
        highFidelityTitle: 'Raisonnement “logique du monde”',
        highFidelityDesc:
            'Contrairement aux modèles traditionnels qui assemblent une scène par mots-clés, GPT Image 1.5 comprend les règles physiques et la logique du monde réel. À partir d’un prompt bref, il infère l’éclairage et les reflets, l’effet de la gravité et des détails historiques précis (par ex. “festival de musique de 1969” adapte tenue et ambiance de l’époque).',
        highFidelityAlt: 'Exemple de raisonnement logique du monde',

        multipleStylesTitle: 'Édition précise en langage naturel',
        multipleStylesDesc:
            'Modifiez une partie d’une image avec de simples instructions, sans masques complexes. Dites “remplace le café sur la table par une tasse de thé vert fumant”, et le modèle remplacera l’objet et ajustera automatiquement lumière et reflets, en conservant le reste inchangé.',
        multipleStylesAlt: 'Exemple d’édition précise en langage naturel',

        preciseTextTitle: 'Mise en page parfaite & rendu du texte',
        preciseTextDesc:
            'Fini les fautes et le texte illisible dans les images IA. GPT Image 1.5 rend des textes longs de façon nette, avec des styles variés et une orthographe correcte—idéal pour affiches, couvertures, maquettes UI et infographies avec graphiques.',
        preciseTextAlt: 'Exemple de mise en page parfaite et rendu du texte',

        interactiveEditingTitle: 'Cohérence des personnages & du style',
        interactiveEditingDesc:
            'Lors de générations en série, le modèle peut “se souvenir” des traits d’un personnage (coiffure, vêtements, visage) ou d’un style artistique. Parfait pour créer BD, storyboards ou visuels marketing cohérents avec une marque.',
        interactiveEditingAlt:
            'Exemple de cohérence des personnages et du style',

        // How to Use Section
        howToUseTitle: 'Comment utiliser GPT Image 1.5 sur WeryAI',
        howToUseSubtitle: 'Démarrez en trois étapes simples',

        step1Title: 'Choisir le modèle',
        step1Description:
            'Sélectionnez le modèle GPT Image 1.5 parmi les modèles d’images IA',

        step2Title: 'Saisir le contenu',
        step2Description:
            'Entrez un prompt ou téléversez une image de référence',

        step3Title: 'Générer l’image',
        step3Description:
            'Cliquez sur “Générer”, patientez puis téléchargez vos images',

        // YouTube Videos Section
        youtubeTitle: 'Vidéos YouTube sur le modèle d’images GPT Image 1.5',

        // X Posts Section
        xPostsTitle: 'Posts X sur le modèle d’images GPT Image 1.5',

        // Explore Other Models Section
        exploreModelsTitle: 'Explorez d’autres modèles d’images IA sur WeryAI',
        model1Title: 'Google Nano Banana Pro',
        model2Title: 'Seedream 4.5',
        model3Title: 'Qwen Image',
        model4Title: 'Dreamina 4.0',

        // FAQ Section
        faqTitle: 'Questions fréquentes',
        faq1Question: 'Quelle différence entre GPT Image 1.5 et DALL·E 3 ?',
        faq1Answer:
            'GPT Image 1.5 est le successeur de DALL·E 3. Les principales différences : une meilleure “compréhension du monde” pour des résultats plus cohérents, une édition locale précise et un rendu du texte fiable, avec une vitesse jusqu’à 4× supérieure.',

        faq2Question: 'Peut-il générer du texte avec précision ?',
        faq2Answer:
            'Oui, c’est l’un des points forts de GPT Image 1.5. Titres, slogans ou extraits de code : le texte est rendu avec une très grande précision, ce qui réduit fortement le “charabia” habituel.',

        faq3Question: 'Faut-il payer pour l’utiliser sur WeryAI ?',
        faq3Answer:
            'Oui. WeryAI propose un quota d’essai gratuit. Comme GPT Image 1.5 est un modèle hautes performances, les images HD ou les éditions en plusieurs étapes peuvent consommer davantage de crédits. Les utilisateurs intensifs peuvent envisager le plan Pro.',

        faq4Question:
            'Puis-je téléverser mes propres images pour les modifier ?',
        faq4Answer:
            'Oui. Utilisez le mode “image vers image” ou “édition”, téléversez une photo, puis donnez des instructions textuelles à GPT Image 1.5 (changer de tenue, changer d’arrière-plan, etc.).',

        faq5Question: 'Où voit-on sa capacité de raisonnement ?',
        faq5Answer:
            'Dans la compréhension d’informations implicites. Par exemple, en écrivant “une chambre de geek des années 80”, le modèle ajoute automatiquement un écran CRT, des posters rétro et des câbles en désordre, sans que vous ayez à tout lister.',

        faq6Question: 'Qui détient les droits commerciaux ?',
        faq6Answer:
            'Selon les politiques d’OpenAI et de WeryAI, les images générées avec GPT Image 1.5 vous appartiennent et peuvent être utilisées commercialement (publicités, packaging, etc.).',

        // CTA Section
        ctaTitle: 'Prêt à créer ?',
        ctaDescription:
            'Essayez GPT Image 1.5 dès maintenant et transformez vos idées en images superbes',
        ctaButton: 'Essayer GPT Image 1.5',
        ctaDisclaimer:
            'Aucune carte bancaire requise — inscrivez-vous pour commencer',
    },
    de: {
        // SEO Meta
        pageTitle:
            'GPT Image 1.5 KI-Bildgenerator – Fortschrittliche DALL·E-3-Alternative',
        pageDescription:
            'Als leistungsstarkes Upgrade von OpenAI DALL·E 3 versteht GPT Image 1.5 komplexe Ideen präziser und ermöglicht das Erstellen und Bearbeiten von Bildern direkt im Chat – dank flüssiger, dialogbasierter Interaktion. Teste GPT Image 1.5 auf WeryAI jetzt kostenlos.',
        pageKeywords:
            'GPT Image 1.5, OpenAI, KI-Bildgenerator, KI-Kunst, künstliche Intelligenz, Bildbearbeitung, DALL·E Alternative, dialogbasierte KI',

        // Open Graph
        ogTitle:
            'GPT Image 1.5 KI-Bildgenerator – Fortschrittliche DALL·E-3-Alternative',
        ogDescription:
            'Ein starkes Upgrade von OpenAI DALL·E 3: GPT Image 1.5 versteht deine Ideen präzise durch natürliche, dialogbasierte Interaktion.',

        // Twitter Card
        twitterTitle:
            'GPT Image 1.5 KI-Bildgenerator – Fortschrittliche DALL·E-3-Alternative',
        twitterDescription:
            'Das große Upgrade von DALL·E 3: GPT Image 1.5 versteht komplexe Ideen via Chat-Editing. Kostenlos testen!',

        // Generator Section
        generatorTitle: 'GPT Image 1.5 Bildgenerator',
        generatorSubtitle:
            'WeryAI integriert jetzt das Modell GPT Image 1.5 tiefgreifend, GPT Image 1.5 ist OpenAIs neuestes Flaggschiff für Bildgenerierung und das erste Vision-Modell mit dem Namen „GPT“ – ein klares Zeichen für das Upgrade nach der DALL·E-Ära. Veröffentlicht im Dezember 2025, geht es über simples „Text-zu-Pixel“-Matching hinaus und nutzt GPT-5-Level-Reasoning, um Physik, Kausalität und komplexe kulturelle Kontexte zu verstehen. GPT Image 1.5 generiert bis zu 4× schneller als die Vorgängergeneration und führt revolutionäres „konversationelles Editing“ ein: Bilddetails lassen sich wie in einem Dokument bearbeiten – und das Problem von wirrem KI-Text wird endlich gelöst. Teste GPT Image 1.5 kostenlos auf WeryAI und erlebe eine KI, die nicht nur zeichnet, sondern dich versteht.',

        // Core Features Section
        coreFeaturesTitle: 'Kernfunktionen von GPT Image 1.5',
        coreFeaturesSubtitle:
            'Entdecke die wichtigsten Fähigkeiten des GPT Image 1.5 KI-Bildgenerators und starte eine revolutionäre Kreativreise',

        // Features
        highFidelityTitle: 'Weltlogik-Reasoning',
        highFidelityDesc:
            'Im Gegensatz zu traditionellen Modellen, die Szenen aus Keywords zusammensetzen, versteht GPT Image 1.5 die Physik und Logik der realen Welt. Aus kurzen Prompts leitet es korrekte Licht-/Reflexionseffekte, Schwerkraftzustände und historisch passende Details ab (z. B. „Musikfestival 1969“ mit zeittypischer Kleidung und Atmosphäre).',
        highFidelityAlt: 'Beispiel für Weltlogik-Reasoning',

        multipleStylesTitle: 'Präzises Bearbeiten per natürlicher Sprache',
        multipleStylesDesc:
            'Bearbeite Teile eines Bildes mit einfachen Anweisungen – ohne komplizierte Masken. Sage „Ersetze den Kaffee auf dem Tisch durch eine dampfende Tasse grünen Tee“, und das Modell tauscht das Objekt aus, passt Licht und Spiegelungen an und lässt den Rest unverändert.',
        multipleStylesAlt:
            'Beispiel für präzises Bearbeiten per natürlicher Sprache',

        preciseTextTitle: 'Perfektes Layout & Textrendering',
        preciseTextDesc:
            'Schluss mit Tippfehlern und unleserlichem KI-Text. GPT Image 1.5 rendert lange Texte klar, in vielfältigen Stilen und mit korrekter Schreibweise – ideal für Poster, Buchcover, UI-Mockups und Infografiken mit Diagrammen.',
        preciseTextAlt: 'Beispiel für perfektes Layout und Textrendering',

        interactiveEditingTitle: 'Konsistenz von Charakter & Stil',
        interactiveEditingDesc:
            'Bei Seriengenerationen kann sich das Modell bestimmte Charaktermerkmale (Frisur, Kleidung, Gesicht) oder einen Kunststil „merken“. So lassen sich Comics, Storyboards oder markenkonsistente Marketing-Assets leicht erstellen.',
        interactiveEditingAlt: 'Beispiel für Charakter- und Stilkonsistenz',

        // How to Use Section
        howToUseTitle: 'So nutzt du GPT Image 1.5 auf WeryAI',
        howToUseSubtitle: 'In drei einfachen Schritten loslegen',

        step1Title: 'Modell auswählen',
        step1Description:
            'Wähle in den KI-Bildmodellen das Modell GPT Image 1.5 aus',

        step2Title: 'Inhalt eingeben',
        step2Description:
            'Gib einen Prompt ein oder lade ein Referenzbild hoch',

        step3Title: 'Bild generieren',
        step3Description:
            'Klicke auf „Generieren“, warte und lade deine Bilder herunter',

        // YouTube Videos Section
        youtubeTitle: 'YouTube-Videos zum Bildmodell GPT Image 1.5',

        // X Posts Section
        xPostsTitle: 'X-Posts zum Bildmodell GPT Image 1.5',

        // Explore Other Models Section
        exploreModelsTitle: 'Entdecke weitere KI-Bildmodelle auf WeryAI',
        model1Title: 'Google Nano Banana Pro',
        model2Title: 'Seedream 4.5',
        model3Title: 'Qwen Image',
        model4Title: 'Dreamina 4.0',

        // FAQ Section
        faqTitle: 'Häufige Fragen',
        faq1Question: 'Worin unterscheidet sich GPT Image 1.5 von DALL·E 3?',
        faq1Answer:
            'GPT Image 1.5 ist der Nachfolger von DALL·E 3. Die wichtigsten Unterschiede: stärkeres „Weltverständnis“ für logischere Ergebnisse, präzises lokales Editing und zuverlässiges Textrendering – und bis zu 4× schneller.',

        faq2Question: 'Kann es Text korrekt erzeugen?',
        faq2Answer:
            'Ja, das ist ein großes Highlight von GPT Image 1.5. Ob englische Titel, Slogans oder Code-Snippets – der Text wird mit sehr hoher Genauigkeit gerendert und das alte „KI-Gekrakel“ weitgehend beseitigt.',

        faq3Question: 'Muss ich auf WeryAI dafür bezahlen?',
        faq3Answer:
            'Ja. WeryAI bietet ein kostenloses Testkontingent. Da GPT Image 1.5 ein High-Performance-Modell ist, können HD-Generierungen oder mehrstufige Edits mehr Credits verbrauchen. Vielnutzer sollten ein Upgrade auf den Pro-Plan erwägen.',

        faq4Question: 'Kann ich eigene Bilder hochladen und bearbeiten?',
        faq4Answer:
            'Ja. Nutze den Modus „Image-to-Image“ oder „Edit“, lade ein Foto hoch und gib dann Textanweisungen, damit GPT Image 1.5 es verändert (z. B. Outfit oder Hintergrund).',

        faq5Question: 'Woran erkennt man seine Reasoning-Fähigkeiten?',
        faq5Answer:
            'An der Interpretation impliziter Informationen. Wenn du z. B. „ein Geek-Zimmer aus den 80ern“ eingibst, ergänzt das Modell automatisch passende Details wie einen CRT-Monitor, Retro-Poster und Kabelsalat – ohne dass du alles einzeln aufzählen musst.',

        faq6Question: 'Wem gehören die kommerziellen Rechte?',
        faq6Answer:
            'Laut den Richtlinien von OpenAI und WeryAI gehören dir die mit GPT Image 1.5 erzeugten Bilder, und du kannst sie kommerziell nutzen (z. B. Werbung, Verpackungen).',

        // CTA Section
        ctaTitle: 'Bereit loszulegen?',
        ctaDescription:
            'Teste GPT Image 1.5 jetzt und verwandle deine Ideen in beeindruckende Bilder',
        ctaButton: 'GPT Image 1.5 jetzt testen',
        ctaDisclaimer:
            'Keine Kreditkarte erforderlich – registrieren und loslegen',
    },
    ru: {
        // SEO Meta
        pageTitle:
            'GPT Image 1.5 генератор изображений ИИ — продвинутая альтернатива DALL·E 3',
        pageDescription:
            'Как мощное обновление OpenAI DALL·E 3, GPT Image 1.5 точнее понимает сложные идеи и позволяет создавать и редактировать изображения прямо в чате благодаря плавному диалоговому взаимодействию. Попробуйте новейший GPT Image 1.5 на WeryAI бесплатно.',
        pageKeywords:
            'GPT Image 1.5, OpenAI, генератор изображений ИИ, ИИ-арт, искусственный интеллект, редактирование изображений, альтернатива DALL·E, диалоговый ИИ',

        // Open Graph
        ogTitle:
            'GPT Image 1.5 генератор изображений ИИ — продвинутая альтернатива DALL·E 3',
        ogDescription:
            'Мощное обновление OpenAI DALL·E 3: GPT Image 1.5 точно понимает вашу идею через естественное диалоговое взаимодействие.',

        // Twitter Card
        twitterTitle:
            'GPT Image 1.5 генератор изображений ИИ — продвинутая альтернатива DALL·E 3',
        twitterDescription:
            'Большое обновление DALL·E 3. GPT Image 1.5 понимает сложные идеи благодаря диалоговому редактированию. Попробуйте бесплатно!',

        // Generator Section
        generatorTitle: 'GPT Image 1.5 генератор изображений',
        generatorSubtitle:
            'WeryAI теперь глубоко интегрировал модель GPT Image 1.5, GPT Image 1.5 — новейшая флагманская модель OpenAI для генерации изображений и первая визуальная модель с названием “GPT”, знаменующая официальный апгрейд после эпохи DALL·E. Выпущенная в декабре 2025 года, она выходит за рамки простого “текст → пиксели” и использует рассуждение уровня GPT-5, чтобы понимать физику, причинно-следственные связи и сложный культурный контекст. GPT Image 1.5 генерирует до 4× быстрее предыдущего поколения и вводит революционное “диалоговое редактирование”, позволяя менять детали как в документе — при этом наконец решая давнюю проблему нечитаемого текста на ИИ-картинках. Попробуйте GPT Image 1.5 на WeryAI бесплатно и почувствуйте творческий ИИ, который не просто рисует — он понимает вас.',

        // Core Features Section
        coreFeaturesTitle: 'Ключевые возможности GPT Image 1.5',
        coreFeaturesSubtitle:
            'Изучите основные возможности генератора изображений ИИ GPT Image 1.5 и начните революционное творческое путешествие',

        // Features
        highFidelityTitle: 'Рассуждение “логики мира”',
        highFidelityDesc:
            'В отличие от традиционных моделей, которые “склеивают” сцену из ключевых слов, GPT Image 1.5 понимает физику и логику реального мира. По короткому промпту он выводит корректные свет и отражения, состояния объектов под действием гравитации и точные исторические детали (например, “музыкальный фестиваль 1969 года” — соответствующая одежда и атмосфера эпохи).',
        highFidelityAlt: 'Пример рассуждения логики мира',

        multipleStylesTitle: 'Точное редактирование на естественном языке',
        multipleStylesDesc:
            'Редактируйте части изображения простыми инструкциями — без сложных масок. Скажите: “замени кофе на столе на дымящуюся чашку зелёного чая”, и модель заменит объект и автоматически подстроит свет и отражения, сохранив остальное без изменений.',
        multipleStylesAlt:
            'Пример точного редактирования на естественном языке',

        preciseTextTitle: 'Идеальная верстка и отрисовка текста',
        preciseTextDesc:
            'Больше никаких опечаток и “кракозябр” в тексте. GPT Image 1.5 умеет чётко отрисовывать длинные тексты в разных стилях с правильным написанием — идеально для постеров, обложек, UI-макетов и инфографики с графиками.',
        preciseTextAlt: 'Пример идеальной верстки и отрисовки текста',

        interactiveEditingTitle: 'Стабильность персонажа и стиля',
        interactiveEditingDesc:
            'При серии генераций модель может “запоминать” особенности персонажа (причёска, одежда, черты лица) или определённый художественный стиль. Это помогает легко создавать комиксы, сториборды или маркетинговые материалы с единым стилем бренда.',
        interactiveEditingAlt: 'Пример стабильности персонажа и стиля',

        // How to Use Section
        howToUseTitle: 'Как использовать GPT Image 1.5 на WeryAI',
        howToUseSubtitle: 'Начните творить за три простых шага',

        step1Title: 'Выберите модель',
        step1Description: 'Выберите GPT Image 1.5 среди моделей изображений ИИ',

        step2Title: 'Введите запрос',
        step2Description:
            'Введите промпт или загрузите референсное изображение',

        step3Title: 'Сгенерируйте изображение',
        step3Description:
            'Нажмите кнопку генерации, дождитесь результата и скачайте изображения',

        // YouTube Videos Section
        youtubeTitle: 'Видео на YouTube о модели изображений GPT Image 1.5',

        // X Posts Section
        xPostsTitle: 'Посты в X о модели изображений GPT Image 1.5',

        // Explore Other Models Section
        exploreModelsTitle: 'Исследуйте другие модели изображений ИИ на WeryAI',
        model1Title: 'Google Nano Banana Pro',
        model2Title: 'Seedream 4.5',
        model3Title: 'Qwen Image',
        model4Title: 'Dreamina 4.0',

        // FAQ Section
        faqTitle: 'Часто задаваемые вопросы',
        faq1Question: 'Чем GPT Image 1.5 отличается от DALL·E 3?',
        faq1Answer:
            'GPT Image 1.5 — преемник DALL·E 3. Главные отличия: более сильное “понимание мира” для логичных результатов, точное локальное редактирование и надёжная генерация текста, а также скорость до 4× выше.',

        faq2Question: 'Он умеет генерировать точный текст?',
        faq2Answer:
            'Да, это одна из главных фишек GPT Image 1.5. Он с высокой точностью отрисовывает английские заголовки, слоганы и даже фрагменты кода, практически избавляя от прежнего “ИИ-кракозябр”.',

        faq3Question: 'Нужно ли платить за использование на WeryAI?',
        faq3Answer:
            'Да. WeryAI предоставляет бесплатную пробную квоту. Поскольку GPT Image 1.5 — высокопроизводительная модель, генерация в высоком разрешении или многошаговое редактирование могут расходовать больше кредитов. Активным пользователям стоит рассмотреть план Pro.',

        faq4Question: 'Можно ли загрузить свои изображения и редактировать их?',
        faq4Answer:
            'Да. Используйте режим “image-to-image” или “edit”, загрузите фото и дайте текстовые инструкции, чтобы GPT Image 1.5 внёс изменения (например, сменил одежду или фон).',

        faq5Question: 'Где проявляется его способность к рассуждению?',
        faq5Answer:
            'В понимании скрытых деталей. Например, достаточно написать “комната гика 80-х”, и модель сама добавит характерные элементы эпохи: CRT‑монитор, ретро‑постеры, спутанные провода — без необходимости перечислять всё вручную.',

        faq6Question: 'Кому принадлежат коммерческие права?',
        faq6Answer:
            'Согласно политикам OpenAI и WeryAI, изображения, созданные вами с GPT Image 1.5, принадлежат вам, и вы можете использовать их в коммерческих целях (реклама, упаковка и т. п.).',

        // CTA Section
        ctaTitle: 'Готовы начать создавать?',
        ctaDescription:
            'Попробуйте GPT Image 1.5 прямо сейчас и превратите идеи в потрясающие изображения',
        ctaButton: 'Попробовать GPT Image 1.5',
        ctaDisclaimer: 'Кредитная карта не требуется — достаточно регистрации',
    },
    pt: {
        // SEO Meta
        pageTitle:
            'Gerador de Imagens com IA GPT Image 1.5 - Alternativa avançada ao DALL·E 3',
        pageDescription:
            'Como uma poderosa atualização do OpenAI DALL·E 3, o GPT Image 1.5 entende ideias complexas com mais precisão e permite criar e editar imagens diretamente no chat com interações conversacionais fluidas. Experimente o GPT Image 1.5 no WeryAI gratuitamente hoje.',
        pageKeywords:
            'GPT Image 1.5, OpenAI, gerador de imagens IA, arte com IA, inteligência artificial, edição de imagens, alternativa ao DALL·E, IA conversacional',

        // Open Graph
        ogTitle:
            'Gerador de Imagens com IA GPT Image 1.5 - Alternativa avançada ao DALL·E 3',
        ogDescription:
            'Uma poderosa atualização do OpenAI DALL·E 3: o GPT Image 1.5 entende sua ideia com precisão por meio de interação conversacional.',

        // Twitter Card
        twitterTitle:
            'Gerador de Imagens com IA GPT Image 1.5 - Alternativa avançada ao DALL·E 3',
        twitterDescription:
            'A grande evolução do DALL·E 3. GPT Image 1.5 entende ideias complexas com edição conversacional. Teste grátis!',

        // Generator Section
        generatorTitle: 'Gerador de Imagens GPT Image 1.5',
        generatorSubtitle:
            'O WeryAI agora integra profundamente o modelo GPT Image 1.5, marcando uma atualização definitiva da era DALL·E. Lançado em dezembro de 2025, ele vai além do simples “texto para pixels” e utiliza raciocínio de nível GPT-5 para entender física, causalidade e contextos culturais complexos. O GPT Image 1.5 gera até 4× mais rápido que a geração anterior e introduz uma revolucionária “edição conversacional”, permitindo ajustar detalhes como se você estivesse editando um documento — e finalmente resolve o antigo problema de textos ilegíveis em imagens geradas por IA. Experimente o GPT Image 1.5 no WeryAI gratuitamente e sinta uma criação inteligente que não só desenha: ela entende você.',

        // Core Features Section
        coreFeaturesTitle: 'Recursos principais do GPT Image 1.5',
        coreFeaturesSubtitle:
            'Explore as principais capacidades do gerador de imagens com IA GPT Image 1.5 e comece uma jornada criativa revolucionária',

        // Features
        highFidelityTitle: 'Raciocínio com lógica do mundo',
        highFidelityDesc:
            'Ao contrário de modelos tradicionais que montam cenas com palavras-chave, o GPT Image 1.5 entende a física e a lógica do mundo real. A partir de prompts curtos, ele infere iluminação e reflexos corretos, estados sob gravidade e detalhes históricos precisos (por exemplo, “festival de música de 1969” combina roupas e atmosfera da época).',
        highFidelityAlt: 'Exemplo de raciocínio com lógica do mundo',

        multipleStylesTitle: 'Edição precisa em linguagem natural',
        multipleStylesDesc:
            'Edite partes de uma imagem com instruções simples — sem máscaras complexas. Diga “troque o café na mesa por uma xícara de chá verde fumegante”, e o modelo substitui o objeto e ajusta automaticamente luz e reflexos, mantendo o restante intacto.',
        multipleStylesAlt: 'Exemplo de edição precisa em linguagem natural',

        preciseTextTitle: 'Layout perfeito e renderização de texto',
        preciseTextDesc:
            'Chega de erros de ortografia e texto ilegível. O GPT Image 1.5 consegue renderizar textos longos com clareza, em vários estilos e com grafia correta — ideal para pôsteres, capas de livros, mockups de UI e infográficos com gráficos.',
        preciseTextAlt: 'Exemplo de layout perfeito e renderização de texto',

        interactiveEditingTitle: 'Consistência de personagem e estilo',
        interactiveEditingDesc:
            'Ao gerar uma série de imagens, o modelo pode “lembrar” traços específicos do personagem (cabelo, roupas, características faciais) ou um estilo artístico. Isso facilita criar quadrinhos, storyboards ou materiais de marketing consistentes com a marca.',
        interactiveEditingAlt: 'Exemplo de consistência de personagem e estilo',

        // How to Use Section
        howToUseTitle: 'Como usar o GPT Image 1.5 no WeryAI',
        howToUseSubtitle: 'Comece a criar em três passos simples',

        step1Title: 'Escolha o modelo',
        step1Description:
            'Selecione o modelo GPT Image 1.5 entre os modelos de imagem com IA',

        step2Title: 'Insira o conteúdo',
        step2Description: 'Digite um prompt ou envie uma imagem de referência',

        step3Title: 'Gere a imagem',
        step3Description:
            'Clique no botão de gerar, aguarde e faça o download das suas imagens',

        // YouTube Videos Section
        youtubeTitle:
            'Vídeos no YouTube sobre o modelo de imagem GPT Image 1.5',

        // X Posts Section
        xPostsTitle: 'Posts no X sobre o modelo de imagem GPT Image 1.5',

        // Explore Other Models Section
        exploreModelsTitle: 'Explore outros modelos de imagem com IA no WeryAI',
        model1Title: 'Google Nano Banana Pro',
        model2Title: 'Seedream 4.5',
        model3Title: 'Qwen Image',
        model4Title: 'Dreamina 4.0',

        // FAQ Section
        faqTitle: 'Perguntas frequentes',
        faq1Question: 'Qual é a diferença entre GPT Image 1.5 e DALL·E 3?',
        faq1Answer:
            'O GPT Image 1.5 é o sucessor do DALL·E 3. A principal diferença é a “compreensão do mundo”, gerando resultados mais coerentes; além disso, ele oferece edição local precisa e renderização de texto confiável, e é até 4× mais rápido.',

        faq2Question: 'Ele consegue gerar texto com precisão?',
        faq2Answer:
            'Sim — esse é um grande destaque do GPT Image 1.5. Seja título em inglês, slogan ou trecho de código, ele renderiza com altíssima precisão, praticamente eliminando o antigo “texto embaralhado” da IA.',

        faq3Question: 'Preciso pagar para usar no WeryAI?',
        faq3Answer:
            'Sim. O WeryAI oferece uma cota de teste gratuita. Como o GPT Image 1.5 é um modelo de alto desempenho, gerar imagens em alta resolução ou fazer edições em múltiplas etapas pode consumir mais créditos. Usuários intensivos podem preferir o plano Pro.',

        faq4Question: 'Posso enviar minhas próprias imagens para editar?',
        faq4Answer:
            'Sim. Você pode usar o modo “imagem para imagem” ou “editar”, enviar uma foto e então usar instruções em texto para que o GPT Image 1.5 faça alterações (por exemplo, trocar roupa ou fundo).',

        faq5Question: 'Onde aparece a capacidade de raciocínio?',
        faq5Answer:
            'Na compreensão de informações implícitas. Por exemplo, ao digitar “um quarto geek dos anos 80”, o modelo adiciona automaticamente detalhes da época como monitor CRT, pôsteres retrô e cabos bagunçados, sem você precisar listar tudo.',

        faq6Question: 'Quem possui os direitos comerciais?',
        faq6Answer:
            'De acordo com as políticas da OpenAI e do WeryAI, as imagens geradas com o GPT Image 1.5 pertencem a você e podem ser usadas comercialmente (por exemplo, anúncios e embalagens).',

        // CTA Section
        ctaTitle: 'Pronto para começar a criar?',
        ctaDescription:
            'Experimente o GPT Image 1.5 agora e transforme suas ideias em imagens incríveis',
        ctaButton: 'Experimentar GPT Image 1.5 agora',
        ctaDisclaimer:
            'Não é necessário cartão de crédito — cadastre-se para começar',
    },
    it: {
        // SEO Meta
        pageTitle:
            'Generatore di Immagini IA GPT Image 1.5 - Alternativa avanzata a DALL·E 3',
        pageDescription:
            'Come potente aggiornamento di OpenAI DALL·E 3, GPT Image 1.5 comprende idee complesse con maggiore precisione e ti permette di creare e modificare immagini direttamente in chat grazie a un’interazione conversazionale fluida. Provalo gratis su WeryAI oggi stesso.',
        pageKeywords:
            'GPT Image 1.5, OpenAI, generatore di immagini IA, arte IA, intelligenza artificiale, editing immagini, alternativa a DALL·E, IA conversazionale',

        // Open Graph
        ogTitle:
            'Generatore di Immagini IA GPT Image 1.5 - Alternativa avanzata a DALL·E 3',
        ogDescription:
            'Un potente aggiornamento di OpenAI DALL·E 3: GPT Image 1.5 comprende la tua idea con precisione tramite interazione conversazionale.',

        // Twitter Card
        twitterTitle:
            'Generatore di Immagini IA GPT Image 1.5 - Alternativa avanzata a DALL·E 3',
        twitterDescription:
            'Il grande upgrade di DALL·E 3. GPT Image 1.5 capisce idee complesse con editing conversazionale. Provalo gratis!',

        // Generator Section
        generatorTitle: 'Generatore di Immagini GPT Image 1.5',
        generatorSubtitle:
            'WeryAI integra ora in profondità il modello GPT Image 1.5, GPT Image 1.5 è il più recente modello di punta di OpenAI per la generazione di immagini ed è il primo modello visivo con il nome “GPT”, segnando un aggiornamento ufficiale dell’era DALL·E. Rilasciato a dicembre 2025, supera il semplice “testo → pixel” e sfrutta un ragionamento di livello GPT-5 per comprendere fisica, causalità e contesti culturali complessi. GPT Image 1.5 è fino a 4× più veloce della generazione precedente e introduce una rivoluzionaria “modifica conversazionale”, che permette di rifinire i dettagli come se stessi modificando un documento—risolvendo finalmente lo storico problema del testo illeggibile nelle immagini IA. Prova GPT Image 1.5 gratis su WeryAI e scopri una creatività intelligente che non si limita a disegnare: ti capisce.',

        // Core Features Section
        coreFeaturesTitle: 'Funzionalità principali di GPT Image 1.5',
        coreFeaturesSubtitle:
            'Esplora le capacità chiave del generatore di immagini IA GPT Image 1.5 e inizia un percorso creativo rivoluzionario',

        // Features
        highFidelityTitle: 'Ragionamento con logica del mondo',
        highFidelityDesc:
            'A differenza dei modelli tradizionali che compongono scene con parole chiave, GPT Image 1.5 comprende la fisica e la logica del mondo reale. Da prompt brevi, deduce illuminazione e riflessi corretti, stati degli oggetti sotto gravità e dettagli storici accurati (ad es. “festival musicale del 1969” con abiti e atmosfera dell’epoca).',
        highFidelityAlt: 'Esempio di ragionamento con logica del mondo',

        multipleStylesTitle: 'Modifica precisa in linguaggio naturale',
        multipleStylesDesc:
            'Modifica parti di un’immagine con istruzioni semplici, senza maschere complesse. Di’ “sostituisci il caffè sul tavolo con una tazza di tè verde fumante”, e il modello sostituirà l’oggetto e regolerà automaticamente luci e riflessi, mantenendo invariato il resto.',
        multipleStylesAlt: 'Esempio di modifica precisa in linguaggio naturale',

        preciseTextTitle: 'Layout perfetto e resa del testo',
        preciseTextDesc:
            'Addio errori di ortografia e testo “illeggibile”. GPT Image 1.5 può rendere testi lunghi in modo nitido, in stili diversi e con grafia corretta—ideale per poster, copertine, mockup UI e infografiche con grafici.',
        preciseTextAlt: 'Esempio di layout perfetto e resa del testo',

        interactiveEditingTitle: 'Coerenza di personaggio e stile',
        interactiveEditingDesc:
            'Quando generi una serie di immagini, il modello può “ricordare” tratti specifici del personaggio (capelli, abiti, lineamenti) o uno stile artistico. Perfetto per creare fumetti, storyboard o asset marketing coerenti con il brand.',
        interactiveEditingAlt: 'Esempio di coerenza di personaggio e stile',

        // How to Use Section
        howToUseTitle: 'Come usare GPT Image 1.5 su WeryAI',
        howToUseSubtitle: 'Inizia a creare in tre semplici passaggi',

        step1Title: 'Scegli il modello',
        step1Description:
            'Seleziona il modello GPT Image 1.5 tra i modelli di immagini IA',

        step2Title: 'Inserisci i contenuti',
        step2Description:
            'Scrivi un prompt o carica un’immagine di riferimento',

        step3Title: 'Genera l’immagine',
        step3Description:
            'Clicca su “Genera”, attendi e scarica le tue immagini',

        // YouTube Videos Section
        youtubeTitle: 'Video YouTube sul modello di immagini GPT Image 1.5',

        // X Posts Section
        xPostsTitle: 'Post su X sul modello di immagini GPT Image 1.5',

        // Explore Other Models Section
        exploreModelsTitle: 'Esplora altri modelli di immagini IA su WeryAI',
        model1Title: 'Google Nano Banana Pro',
        model2Title: 'Seedream 4.5',
        model3Title: 'Qwen Image',
        model4Title: 'Dreamina 4.0',

        // FAQ Section
        faqTitle: 'Domande frequenti',
        faq1Question: 'Qual è la differenza tra GPT Image 1.5 e DALL·E 3?',
        faq1Answer:
            'GPT Image 1.5 è il successore di DALL·E 3. Le differenze principali sono una migliore “comprensione del mondo” per risultati più coerenti, editing locale preciso e generazione di testo affidabile, oltre a una velocità fino a 4× superiore.',

        faq2Question: 'Può generare testo in modo accurato?',
        faq2Answer:
            'Sì, è uno dei punti di forza di GPT Image 1.5. Che si tratti di titoli in inglese, slogan o frammenti di codice, rende il testo con altissima precisione, dicendo addio al vecchio “testo illeggibile”.',

        faq3Question: 'Su WeryAI è necessario pagare?',
        faq3Answer:
            'Sì. WeryAI offre una quota di prova gratuita. Poiché GPT Image 1.5 è un modello ad alte prestazioni, generare immagini HD o fare modifiche in più passaggi può consumare più crediti. Gli utenti intensivi possono valutare il piano Pro.',

        faq4Question: 'Posso caricare le mie immagini per modificarle?',
        faq4Answer:
            'Sì. Puoi usare la modalità “image-to-image” o “edit”, caricare una foto e poi dare istruzioni testuali a GPT Image 1.5 (ad esempio cambiare vestiti o sfondo).',

        faq5Question: 'Dove si vede la sua capacità di ragionamento?',
        faq5Answer:
            'Nella comprensione delle informazioni implicite. Ad esempio, basta scrivere “una stanza da geek degli anni ’80” e il modello aggiunge automaticamente dettagli come un monitor CRT, poster retrò e cavi in disordine, senza che tu debba elencarli uno per uno.',

        faq6Question: 'A chi appartengono i diritti commerciali?',
        faq6Answer:
            'Secondo le policy di OpenAI e WeryAI, le immagini generate con GPT Image 1.5 appartengono a te e puoi usarle per scopi commerciali (ad esempio pubblicità o packaging).',

        // CTA Section
        ctaTitle: 'Pronto a iniziare a creare?',
        ctaDescription:
            'Prova GPT Image 1.5 ora e trasforma le tue idee in immagini straordinarie',
        ctaButton: 'Prova GPT Image 1.5 ora',
        ctaDisclaimer:
            'Nessuna carta di credito richiesta — registrati per iniziare',
    },
    ar: {
        // SEO Meta
        pageTitle:
            'مولّد الصور بالذكاء الاصطناعي GPT Image 1.5 - بديل متقدم لـ DALL·E 3',
        pageDescription:
            'باعتباره ترقية قوية لنموذج OpenAI DALL·E 3، يفهم GPT Image 1.5 الأفكار المعقّدة بدقة أعلى ويتيح لك إنشاء الصور وتعديلها مباشرة داخل الدردشة عبر تفاعل محادثاتي سلس. جرّب أحدث GPT Image 1.5 على WeryAI مجانًا اليوم.',
        pageKeywords:
            'GPT Image 1.5, OpenAI, مولد صور بالذكاء الاصطناعي, فن بالذكاء الاصطناعي, ذكاء اصطناعي, تحرير الصور, بديل DALL·E, ذكاء محادثاتي',

        // Open Graph
        ogTitle:
            'مولّد الصور بالذكاء الاصطناعي GPT Image 1.5 - بديل متقدم لـ DALL·E 3',
        ogDescription:
            'ترقية قوية لـ OpenAI DALL·E 3: يفهم GPT Image 1.5 أفكارك بدقة عبر تفاعل محادثاتي طبيعي.',

        // Twitter Card
        twitterTitle:
            'مولّد الصور بالذكاء الاصطناعي GPT Image 1.5 - بديل متقدم لـ DALL·E 3',
        twitterDescription:
            'ترقية قوية لـ DALL·E 3. يفهم GPT Image 1.5 الأفكار المعقدة عبر التحرير بالمحادثة. جرّبه مجانًا!',

        // Generator Section
        generatorTitle: 'مولّد الصور GPT Image 1.5',
        generatorSubtitle:
            'يقوم WeryAI الآن بدمج نموذج GPT Image 1.5 بعمق، أُطلق في ديسمبر 2025 ليتجاوز مجرد “مطابقة النص بالبكسل”، ويعتمد على استدلال بمستوى GPT-5 لفهم قوانين الفيزياء والسببية والسياقات الثقافية المعقّدة. لا يقدّم GPT Image 1.5 سرعة توليد أسرع حتى 4× فحسب، بل يقدّم أيضًا “تحريرًا بالمحادثة” ثوريًا يتيح لك تعديل التفاصيل كما تعدّل مستندًا—مع حل مشكلة النصوص المشوّهة في الصور المولّدة بالذكاء الاصطناعي. جرّب GPT Image 1.5 مجانًا على WeryAI واختبر تجربة إبداع لا ترسم فقط—بل تفهمك.',

        // Core Features Section
        coreFeaturesTitle: 'الميزات الأساسية لـ GPT Image 1.5',
        coreFeaturesSubtitle:
            'استكشف القدرات الأساسية لمولّد الصور بالذكاء الاصطناعي GPT Image 1.5 وابدأ رحلة إبداعية ثورية',

        // Features
        highFidelityTitle: 'استدلال بمنطق العالم',
        highFidelityDesc:
            'على عكس النماذج التقليدية التي تركّب المشهد من كلمات مفتاحية، يفهم GPT Image 1.5 فيزياء العالم الحقيقي ومنطقه. ومن خلال مطالبات قصيرة، يستطيع استنتاج إضاءة وانعكاسات صحيحة، وحالات الأجسام تحت تأثير الجاذبية، وتفاصيل تاريخية دقيقة (مثل “مهرجان موسيقي عام 1969” حيث يطابق الملابس والأجواء لتلك الحقبة).',
        highFidelityAlt: 'مثال على استدلال منطق العالم',

        multipleStylesTitle: 'تحرير دقيق باللغة الطبيعية',
        multipleStylesDesc:
            'حرّر أجزاء من صورة موجودة بتعليمات بسيطة دون أقنعة معقّدة. قل: “استبدل القهوة على الطاولة بكوب شاي أخضر يتصاعد منه البخار”، وسيستبدل النموذج العنصر ويعدّل الإضاءة والانعكاسات المحيطة تلقائيًا مع إبقاء باقي الصورة كما هي.',
        multipleStylesAlt: 'مثال على التحرير الدقيق باللغة الطبيعية',

        preciseTextTitle: 'تنسيق مثالي وعرض نص واضح',
        preciseTextDesc:
            'وداعًا للأخطاء الإملائية والنصوص المشوّهة. يستطيع GPT Image 1.5 عرض نصوص طويلة بوضوح وبأنماط متعددة وتهجئة دقيقة—مناسب للملصقات وأغلفة الكتب ونماذج واجهات المستخدم والإنفوغرافيك التي تتضمن مخططات.',
        preciseTextAlt: 'مثال على تنسيق مثالي وعرض نص واضح',

        interactiveEditingTitle: 'اتساق الشخصية والأسلوب',
        interactiveEditingDesc:
            'عند توليد سلسلة من الصور، يمكن للنموذج “تذكّر” سمات شخصية محددة (الشعر، الملابس، ملامح الوجه) أو أسلوب فني معين. يساعد ذلك على إنشاء القصص المصوّرة ولوحات القصة أو مواد تسويقية متسقة مع العلامة التجارية بسهولة.',
        interactiveEditingAlt: 'مثال على اتساق الشخصية والأسلوب',

        // How to Use Section
        howToUseTitle: 'كيفية استخدام GPT Image 1.5 على WeryAI',
        howToUseSubtitle: 'ابدأ الإبداع بثلاث خطوات بسيطة',

        step1Title: 'اختر النموذج',
        step1Description:
            'اختر نموذج GPT Image 1.5 ضمن نماذج صور الذكاء الاصطناعي',

        step2Title: 'أدخل المحتوى',
        step2Description: 'اكتب نصًا إرشاديًا أو ارفع صورة مرجعية',

        step3Title: 'أنشئ الصورة',
        step3Description: 'اضغط زر الإنشاء، ثم انتظر ونزّل صورك',

        // YouTube Videos Section
        youtubeTitle: 'فيديوهات YouTube حول نموذج الصور GPT Image 1.5',

        // X Posts Section
        xPostsTitle: 'منشورات X حول نموذج الصور GPT Image 1.5',

        // Explore Other Models Section
        exploreModelsTitle: 'استكشف نماذج صور ذكاء اصطناعي أخرى على WeryAI',
        model1Title: 'Google Nano Banana Pro',
        model2Title: 'Seedream 4.5',
        model3Title: 'Qwen Image',
        model4Title: 'Dreamina 4.0',

        // FAQ Section
        faqTitle: 'الأسئلة الشائعة',
        faq1Question: 'ما الفرق بين GPT Image 1.5 و DALL·E 3؟',
        faq1Answer:
            'GPT Image 1.5 هو خليفة DALL·E 3. الفروق الأساسية هي امتلاك “فهم للعالم” يجعل النتائج أكثر منطقية، ودعم تحرير موضعي دقيق، وتوليد نصوص موثوق، مع سرعة أعلى حتى 4×.',

        faq2Question: 'هل يمكنه توليد نصوص دقيقة؟',
        faq2Answer:
            'نعم، وهذه إحدى أبرز نقاط قوة GPT Image 1.5. سواء كانت عناوين بالإنجليزية أو شعارات أو مقاطع كود، يمكنه عرض النص بدقة عالية جدًا، ما يقلل بشكل كبير مشكلة “نصوص الذكاء الاصطناعي المشوشة”.',

        faq3Question: 'هل يلزم الدفع لاستخدامه على WeryAI؟',
        faq3Answer:
            'نعم. يوفر WeryAI حصة تجربة مجانية. وبما أن GPT Image 1.5 نموذج عالي الأداء، فقد يستهلك إنشاء صور عالية الدقة أو التحرير متعدد المراحل عددًا أكبر من الرصيد. قد يرغب المستخدمون المكثفون في الترقية إلى خطة Pro.',

        faq4Question: 'هل يمكنني رفع صوري الخاصة لتحريرها؟',
        faq4Answer:
            'نعم. يمكنك استخدام وضع “صورة إلى صورة” أو “تحرير”، ورفع صورة موجودة، ثم استخدام تعليمات نصية ليقوم GPT Image 1.5 بتعديلها (مثل تغيير الملابس أو الخلفية).',

        faq5Question: 'أين تظهر قدرته على الاستدلال؟',
        faq5Answer:
            'في فهمه للمعلومات الضمنية. على سبيل المثال، يكفي أن تكتب “غرفة مهووس تقنيات من الثمانينيات”، وسيضيف النموذج تلقائيًا تفاصيل مناسبة للعصر مثل شاشة CRT وملصقات قديمة وكابلات مبعثرة دون الحاجة لذكرها واحدةً واحدة.',

        faq6Question: 'لمن تعود حقوق الاستخدام التجاري؟',
        faq6Answer:
            'وفقًا لسياسات OpenAI وWeryAI، تعود ملكية الصور التي تنشئها باستخدام GPT Image 1.5 إليك، ويمكنك استخدامها تجاريًا (مثل الإعلانات وتغليف المنتجات).',

        // CTA Section
        ctaTitle: 'هل أنت مستعد لبدء الإبداع؟',
        ctaDescription: 'جرّب GPT Image 1.5 الآن وحوّل أفكارك إلى صور مذهلة',
        ctaButton: 'جرّب GPT Image 1.5 الآن',
        ctaDisclaimer: 'لا حاجة لبطاقة ائتمان — سجّل وابدأ',
        },
    th: {
        // SEO Meta
        pageTitle:
            'เครื่องมือสร้างภาพ AI GPT Image 1.5 - ทางเลือก DALL·E 3 ขั้นสูง',
        pageDescription:
            'ในฐานะการอัปเกรดทรงพลังของ OpenAI DALL·E 3, GPT Image 1.5 เข้าใจไอเดียซับซ้อนได้แม่นยำยิ่งขึ้น และให้คุณสร้างและแก้ไขภาพได้ตรงในแชตผ่านการสนทนาที่ลื่นไหล ลอง GPT Image 1.5 เวอร์ชันล่าสุดบน WeryAI ฟรีวันนี้',
        pageKeywords:
            'GPT Image 1.5, OpenAI, เครื่องมือสร้างภาพ AI, ศิลปะ AI, ปัญญาประดิษฐ์, การแก้ไขภาพ, ทางเลือก DALL·E, AI เชิงสนทนา',

        // Open Graph
        ogTitle:
            'เครื่องมือสร้างภาพ AI GPT Image 1.5 - ทางเลือก DALL·E 3 ขั้นสูง',
        ogDescription:
            'การอัปเกรดทรงพลังของ OpenAI DALL·E 3, GPT Image 1.5 เข้าใจไอเดียของคุณอย่างแม่นยำผ่านการสนทนาแบบเป็นธรรมชาติ',

        // Twitter Card
        twitterTitle:
            'เครื่องมือสร้างภาพ AI GPT Image 1.5 - ทางเลือก DALL·E 3 ขั้นสูง',
        twitterDescription:
            'อัปเกรดครั้งใหญ่จาก OpenAI DALL·E 3 — GPT Image 1.5 เข้าใจไอเดียซับซ้อนผ่านการแก้ไขแบบแชต ลองฟรี!',

        // Generator Section
        generatorTitle: 'เครื่องมือสร้างภาพ GPT Image 1.5',
        generatorSubtitle:
            'ขณะนี้ WeryAI ได้ผสานรวมโมเดล GPT Image 1.5 อย่างลึกซึ้งแล้ว ขณะนี้ WeryAI ได้ผสานรวมโมเดล GPT Image 1.5 อย่างลึกซึ้งแล้ว GPT Image 1.5 คือโมเดลสร้างภาพเรือธงรุ่นล่าสุดของ OpenAI และเป็นวิชันโมเดลตัวแรกที่ใช้แบรนด์ “GPT” ถือเป็นก้าวสำคัญที่ก้าวข้ามยุค DALL·E เปิดตัวในเดือนธันวาคม 2025 และก้าวข้ามการจับคู่ “ข้อความ-พิกเซล” แบบเดิม โดยใช้การให้เหตุผลระดับ GPT-5 เพื่อเข้าใจฟิสิกส์ เหตุและผล และบริบททางวัฒนธรรมอย่างละเอียด GPT Image 1.5 เร็วกว่ารุ่นก่อนถึง 4 เท่า และนำเสนอ “การแก้ไขแบบสนทนา” ที่ปฏิวัติวงการ ให้คุณปรับรายละเอียดภาพได้เหมือนแก้ไขเอกสาร พร้อมแก้ปัญหาข้อความมั่วในภาพ AI ที่เป็นมานาน ลอง GPT Image 1.5 บน WeryAI ฟรี แล้วสัมผัสผู้สร้าง AI ที่ไม่ได้แค่วาด—แต่เข้าใจคุณ',

        // Core Features Section
        coreFeaturesTitle: 'คุณสมบัติหลักของ GPT Image 1.5',
        coreFeaturesSubtitle:
            'สำรวจความสามารถหลักของเครื่องมือสร้างภาพ AI GPT Image 1.5 และเริ่มต้นการเดินทางสร้างสรรค์ครั้งใหม่',

        // Features
        highFidelityTitle: 'การให้เหตุผลตามตรรกะของโลก',
        highFidelityDesc:
            'ต่างจากโมเดลดั้งเดิมที่ต่อฉากจากคีย์เวิร์ด GPT Image 1.5 เข้าใจฟิสิกส์และตรรกะของโลกจริง จากพรอมป์ต์สั้นๆ สามารถอนุมานแสงและเงาที่ถูกต้อง แรงโน้มถ่วง สถานะวัตถุ และรายละเอียดตามยุคสมัยได้อย่างแม่นยำ (เช่น “เทศกาลดนตรีปี 1969” จะตรงกับชุดและบรรยากาศของยุคนั้น)',
        highFidelityAlt: 'ตัวอย่างการให้เหตุผลตามตรรกะของโลก',

        multipleStylesTitle: 'การแก้ไขด้วยภาษาธรรมชาติอย่างแม่นยำ',
        multipleStylesDesc:
            'แก้ไขส่วนของภาพเดิมด้วยคำสั่งง่ายๆ ไม่ต้องมาสก์ซับซ้อน เพียงบอกว่า “เปลี่ยนกาแฟบนโต๊ะเป็นชาเขียวร้อน” โมเดลจะสลับวัตถุและปรับแสงสะท้อนรอบข้างอัตโนมัติ โดยคงส่วนอื่นไว้เหมือนเดิม',
        multipleStylesAlt: 'ตัวอย่างการแก้ไขด้วยภาษาธรรมชาติอย่างแม่นยำ',

        preciseTextTitle: 'เลย์เอาต์สมบูรณ์แบบและการเรนเดอร์ข้อความ',
        preciseTextDesc:
            'บอกลาอักขระผิดและข้อความมั่วในภาพ AI ได้เลย GPT Image 1.5 เรนเดอร์ข้อความยาวได้ชัดเจน หลายสไตล์ และสะกดถูกต้อง เหมาะสำหรับโปสเตอร์ ปกหนังสือ ม็อกอัป UI และภาพแนวอินโฟกราฟิกพร้อมกราฟ',
        preciseTextAlt: 'ตัวอย่างเลย์เอาต์และการเรนเดอร์ข้อความสมบูรณ์แบบ',

        interactiveEditingTitle: 'ความสม่ำเสมอของตัวละครและสไตล์',
        interactiveEditingDesc:
            'เมื่อสร้างภาพเป็นชุด โมเดลสามารถ “จำ” ลักษณะตัวละคร (ทรงผม เสื้อผ้า ใบหน้า) หรือสไตล์ศิลป์เฉพาะได้ ทำให้ง่ายต่อการสร้างคอมิก สตอรีบอร์ด หรือสื่อการตลาดที่สอดคล้องกับแบรนด์',
        interactiveEditingAlt: 'ตัวอย่างความสม่ำเสมอของตัวละครและสไตล์',

        // How to Use Section
        howToUseTitle: 'วิธีใช้ GPT Image 1.5 บน WeryAI',
        howToUseSubtitle: 'เริ่มสร้างสรรค์ในสามขั้นตอนง่ายๆ',

        step1Title: 'เลือกโมเดล',
        step1Description: 'เลือกโมเดล GPT Image 1.5 ในโมเดลภาพ AI',

        step2Title: 'ป้อนเนื้อหา',
        step2Description: 'พิมพ์พรอมป์ต์หรืออัปโหลดภาพอ้างอิง',

        step3Title: 'สร้างภาพ',
        step3Description:
            'คลิกปุ่มสร้าง จากนั้นรอและดาวน์โหลดภาพของคุณ',

        // YouTube Videos Section
        youtubeTitle: 'วิดีโอ YouTube เกี่ยวกับโมเดลภาพ GPT Image 1.5',

        // X Posts Section
        xPostsTitle: 'โพสต์ X เกี่ยวกับโมเดลภาพ GPT Image 1.5',

        // Explore Other Models Section
        exploreModelsTitle: 'สำรวจโมเดลสร้างภาพ AI อื่นๆ บน WeryAI',
        model1Title: 'Google Nano Banana Pro',
        model2Title: 'Seedream 4.5',
        model3Title: 'Qwen Image',
        model4Title: 'Dreamina 4.0',

        // FAQ Section
        faqTitle: 'คำถามที่พบบ่อย',
        faq1Question:
            'GPT Image 1.5 ต่างจาก DALL·E 3 อย่างไร?',
        faq1Answer:
            'GPT Image 1.5 เป็นรุ่นต่อจาก DALL·E 3 ความต่างหลักคือความเข้าใจโลกที่ลึกขึ้นเพื่อผลลัพธ์ที่มีตรรกะมากขึ้น การแก้ไขเฉพาะจุดอย่างแม่นยำ และการเรนเดอร์ข้อความที่เชื่อถือได้ — แถมยังเร็วขึ้นถึง 4 เท่า',

        faq2Question: 'สามารถสร้างข้อความได้แม่นยำไหม?',
        faq2Answer:
            'ได้ นี่คือจุดเด่นหลักของ GPT Image 1.5 ไม่ว่าจะเป็นหัวข้อภาษาอังกฤษ สโลแกน หรือโค้ดสั้นๆ ก็เรนเดอร์ข้อความได้แม่นยำสูง ลดปัญหา “ข้อความมั่วจาก AI” ได้อย่างมาก',

        faq3Question: 'ต้องจ่ายเงินเพื่อใช้บน WeryAI ไหม?',
        faq3Answer:
            'ใช่ WeryAI มีโควต้าทดลองฟรี เนื่องจาก GPT Image 1.5 เป็นโมเดลประสิทธิภาพสูง การสร้างภาพความละเอียดสูงหรือการแก้ไขหลายขั้นตอนอาจใช้เครดิตมากขึ้น ผู้ใช้หนักอาจต้องอัปเกรดเป็นแพ็กเกจ Pro',

        faq4Question: 'อัปโหลดภาพของตัวเองเพื่อแก้ไขได้ไหม?',
        faq4Answer:
            'ได้ คุณสามารถใช้โหมด “image-to-image” หรือ “edit” เพื่ออัปโหลดภาพเดิม แล้วใช้คำสั่งข้อความให้ GPT Image 1.5 ปรับแก้ (เช่น เปลี่ยนชุดหรือพื้นหลัง)',

        faq5Question: 'การให้เหตุผลของมันแสดงออกตรงไหน?',
        faq5Answer:
            'อยู่ที่การเข้าใจรายละเอียดที่สื่อเป็นนัย เช่น หากพิมพ์ “ห้องของคนคลั่งเทคยุค 80s” โมเดลจะเติมรายละเอียดตามยุค เช่น จอ CRT โปสเตอร์ย้อนยุค และสายเคเบิลรกๆ โดยไม่ต้องระบุทีละอย่าง',

        faq6Question: 'สิทธิ์เชิงพาณิชย์เป็นของใคร?',
        faq6Answer:
            'ตามนโยบายของ OpenAI และ WeryAI ภาพที่คุณสร้างด้วย GPT Image 1.5 เป็นของคุณ และสามารถใช้เชิงพาณิชย์ได้ (เช่น โฆษณา บรรจุภัณฑ์สินค้า)',

        // CTA Section
        ctaTitle: 'พร้อมเริ่มสร้างสรรค์แล้วหรือยัง?',
        ctaDescription:
            'ลอง GPT Image 1.5 ตอนนี้และเปลี่ยนไอเดียของคุณให้เป็นภาพที่น่าทึ่ง',
        ctaButton: 'ลอง GPT Image 1.5 ตอนนี้',
        ctaDisclaimer: 'ไม่ต้องใช้บัตรเครดิต — สมัครแล้วเริ่มได้เลย',
        },
    da: {
        // SEO Meta
        pageTitle:
            'GPT Image 1.5 AI-billedgenerator - Avanceret DALL·E 3-alternativ',
        pageDescription:
            'Som en kraftfuld opgradering af OpenAI’s DALL·E 3 forstår GPT Image 1.5 komplekse ideer mere præcist og lader dig skabe og redigere billeder direkte i chatten gennem glidende samtaler. Prøv den nyeste GPT Image 1.5 på WeryAI gratis i dag.',
        pageKeywords:
            'GPT Image 1.5, OpenAI, AI-billedgenerator, AI-kunst, kunstig intelligens, billedredigering, DALL·E-alternativ, samtale-AI',

        // Open Graph
        ogTitle:
            'GPT Image 1.5 AI-billedgenerator - Avanceret DALL·E 3-alternativ',
        ogDescription:
            'En kraftfuld opgradering af OpenAI’s DALL·E 3, GPT Image 1.5 forstår dine ideer præcist gennem naturlig samtale.',

        // Twitter Card
        twitterTitle:
            'GPT Image 1.5 AI-billedgenerator - Avanceret DALL·E 3-alternativ',
        twitterDescription:
            'En stor opgradering af OpenAI’s DALL·E 3 — GPT Image 1.5 forstår komplekse ideer via chat-baseret redigering. Prøv gratis!',

        // Generator Section
        generatorTitle: 'GPT Image 1.5 billedgenerator',
        generatorSubtitle:
            'WeryAI har nu integreret modellen GPT Image 1.5 i dybden, GPT Image 1.5 er OpenAIs nyeste flagskibsmodel til billedgenerering og den første vision-model brandet med “GPT”, hvilket markerer et tydeligt skridt ud over DALL·E-æraen. Udgivet i december 2025 går den videre end simpel “tekst-til-pixel”-matchning og udnytter i stedet GPT-5-niveau ræsonnering til at forstå fysik, årsagssammenhænge og nuanceret kulturel kontekst. GPT Image 1.5 er op til 4× hurtigere end forrige generation og introducerer revolutionerende “konversationel redigering”, der lader dig finpudse billeddetaljer som at redigere et dokument—samtidig med at den endelig løser det langvarige problem med forvredet AI-genereret tekst. Prøv GPT Image 1.5 på WeryAI gratis og oplev en AI-skaber, der ikke bare tegner—den forstår dig.',

        // Core Features Section
        coreFeaturesTitle: 'GPT Image 1.5 kernefunktioner',
        coreFeaturesSubtitle:
            'Udforsk kernekapaciteterne i GPT Image 1.5 AI-billedgeneratoren og start en revolutionerende kreativ rejse',

        // Features
        highFidelityTitle: 'Verdenslogisk ræsonnering',
        highFidelityDesc:
            'I modsætning til traditionelle modeller, der syr scener sammen fra nøgleord, forstår GPT Image 1.5 virkelighedens fysik og logik. Fra korte prompts kan den udlede korrekt belysning og refleksioner, tyngdekraft og objekttilstande samt historisk korrekte detaljer (f.eks. “en musikfestival i 1969” matcher tidstypisk tøj og atmosfære).',
        highFidelityAlt: 'Eksempel på verdenslogisk ræsonnering',

        multipleStylesTitle: 'Præcis redigering i naturligt sprog',
        multipleStylesDesc:
            'Rediger dele af et eksisterende billede med enkle instruktioner—uden kompleks maskering. Sig “erstat kaffen på bordet med en dampende kop grøn te”, og modellen skifter objektet og justerer automatisk lys og refleksioner omkring det, mens alt andet forbliver uændret.',
        multipleStylesAlt: 'Eksempel på præcis redigering i naturligt sprog',

        preciseTextTitle: 'Perfekt layout og tekstrendering',
        preciseTextDesc:
            'Sig farvel til stavefejl og forvredet tekst i AI-billeder. GPT Image 1.5 kan renderere lange tekster tydeligt, i forskellige stilarter, med korrekt stavning—ideelt til plakater, bogomslag, UI-mockups og infografik-lignende visuals med diagrammer.',
        preciseTextAlt: 'Eksempel på perfekt layout og tekstrendering',

        interactiveEditingTitle: 'Konsistens i karakter og stil',
        interactiveEditingDesc:
            'Når du genererer en serie billeder, kan modellen “huske” specifikke karaktertræk (hår, tøj, ansigtstræk) eller en bestemt kunststil. Det gør det let at skabe tegneserier, storyboards eller brand-konsistente marketingmaterialer.',
        interactiveEditingAlt: 'Eksempel på konsistens i karakter og stil',

        // How to Use Section
        howToUseTitle: 'Sådan bruger du GPT Image 1.5 på WeryAI',
        howToUseSubtitle: 'Kom i gang i tre enkle trin',

        step1Title: 'Vælg modellen',
        step1Description: 'Vælg GPT Image 1.5-modellen i AI-billedmodeller',

        step2Title: 'Indtast indhold',
        step2Description: 'Skriv en prompt eller upload et referencebillede',

        step3Title: 'Generér billeder',
        step3Description:
            'Klik på generer-knappen, vent og download dine billeder',

        // YouTube Videos Section
        youtubeTitle: 'YouTube-videoer om GPT Image 1.5 billedmodellen',

        // X Posts Section
        xPostsTitle: 'X-opslag om GPT Image 1.5 billedmodellen',

        // Explore Other Models Section
        exploreModelsTitle: 'Udforsk andre AI-billedmodeller på WeryAI',
        model1Title: 'Google Nano Banana Pro',
        model2Title: 'Seedream 4.5',
        model3Title: 'Qwen Image',
        model4Title: 'Dreamina 4.0',

        // FAQ Section
        faqTitle: 'Ofte stillede spørgsmål',
        faq1Question:
            'Hvad er forskellen mellem GPT Image 1.5 og DALL·E 3?',
        faq1Answer:
            'GPT Image 1.5 er efterfølgeren til DALL·E 3. De vigtigste forskelle er dens stærkere “verdensforståelse” for mere logiske output, præcis lokal redigering og pålidelig tekstrendering—samt at den er op til 4× hurtigere.',

        faq2Question: 'Kan den generere nøjagtig tekst?',
        faq2Answer:
            'Ja—det er et af de største højdepunkter ved GPT Image 1.5. Uanset om det er engelske titler, slogans eller kodestumper, rendererer den tekst med meget høj nøjagtighed og eliminerer langt hen ad vejen den gamle “AI-gibberish”.',

        faq3Question: 'Skal jeg betale for at bruge den på WeryAI?',
        faq3Answer:
            'Ja. WeryAI tilbyder en gratis prøvekvote. Da GPT Image 1.5 er en højtydende model, kan generering af HD-billeder eller brug af flertrinsredigering bruge flere credits. Tunge brugere bør overveje at opgradere til Pro-planen.',

        faq4Question: 'Kan jeg uploade mine egne billeder for at redigere?',
        faq4Answer:
            'Ja. Du kan bruge “image-to-image” eller “edit”-tilstand til at uploade et eksisterende foto og derefter bruge tekstinstruktioner til at få GPT Image 1.5 til at ændre det (f.eks. skifte tøj eller baggrunde).',

        faq5Question: 'Hvor viser dens ræsonnering sig?',
        faq5Answer:
            'I måden den forstår implicitte detaljer på. For eksempel, hvis du skriver “et nørdeværelse fra 80’erne”, vil modellen automatisk tilføje tidsrigtige detaljer som en CRT-skærm, retroplakater og rodede kabler—uden at du skal nævne dem én for én.',

        faq6Question: 'Hvem ejer de kommercielle rettigheder?',
        faq6Answer:
            'Ifølge OpenAI- og WeryAI-politikker tilhører de billeder, du genererer med GPT Image 1.5, dig, og du kan bruge dem kommercielt (f.eks. annoncer og produktindpakning).',

        // CTA Section
        ctaTitle: 'Klar til at skabe?',
        ctaDescription:
            'Prøv GPT Image 1.5 nu og forvandl dine ideer til fantastiske billeder',
        ctaButton: 'Prøv GPT Image 1.5 nu',
        ctaDisclaimer: 'Intet kreditkort kræves — tilmeld dig og kom i gang',
        },
    no: {
        // SEO Meta
        pageTitle:
            'GPT Image 1.5 AI-bildegenerator - Avansert DALL·E 3-alternativ',
        pageDescription:
            'Som en kraftig oppgradering av OpenAIs DALL·E 3 forstår GPT Image 1.5 komplekse ideer mer presist og lar deg skape og redigere bilder direkte i chatten gjennom smidige samtaler. Prøv den nyeste GPT Image 1.5 på WeryAI gratis i dag.',
        pageKeywords:
            'GPT Image 1.5, OpenAI, AI-bildegenerator, AI-kunst, kunstig intelligens, bilderedigering, DALL·E-alternativ, samtale-AI',

        // Open Graph
        ogTitle:
            'GPT Image 1.5 AI-bildegenerator - Avansert DALL·E 3-alternativ',
        ogDescription:
            'En kraftig oppgradering av OpenAIs DALL·E 3, GPT Image 1.5 forstår ideene dine presist gjennom naturlig samtale.',

        // Twitter Card
        twitterTitle:
            'GPT Image 1.5 AI-bildegenerator - Avansert DALL·E 3-alternativ',
        twitterDescription:
            'En stor oppgradering av OpenAIs DALL·E 3 — GPT Image 1.5 forstår komplekse ideer via chat-basert redigering. Prøv gratis!',

        // Generator Section
        generatorTitle: 'GPT Image 1.5 bildegenerator',
        generatorSubtitle:
            'WeryAI har nå integrert modellen GPT Image 1.5 i dybden, GPT Image 1.5 er OpenAIs nyeste flaggskipmodell for bildegenerering og den første visjonsmodellen merket med “GPT”, som markerer et tydelig steg forbi DALL·E-æraen. Lansert i desember 2025 går den utover enkel “tekst-til-piksel”-matching og bruker i stedet GPT-5-nivå resonnering for å forstå fysikk, årsakssammenheng og nyansert kulturell kontekst. GPT Image 1.5 er opptil 4× raskere enn forrige generasjon og introduserer revolusjonerende “konversasjonsredigering”, som lar deg finjustere bildedetaljer som å redigere et dokument—samtidig som den endelig løser det langvarige problemet med forvrengt AI-generert tekst. Prøv GPT Image 1.5 på WeryAI gratis og opplev en AI-skaper som ikke bare tegner—den forstår deg.',

        // Core Features Section
        coreFeaturesTitle: 'Kjernefunksjoner i GPT Image 1.5',
        coreFeaturesSubtitle:
            'Utforsk kjernekapasitetene i GPT Image 1.5 AI-bildegenerator og start en revolusjonerende kreativ reise',

        // Features
        highFidelityTitle: 'Verdenslogisk resonnering',
        highFidelityDesc:
            'I motsetning til tradisjonelle modeller som syr scener sammen av nøkkelord, forstår GPT Image 1.5 virkelighetens fysikk og logikk. Fra korte prompts kan den utlede korrekt belysning og refleksjoner, tyngdekraft og objekttilstander samt historisk korrekte detaljer (f.eks. “en musikkfestival i 1969” vil matche tidstypiske antrekk og atmosfære).',
        highFidelityAlt: 'Eksempel på verdenslogisk resonnering',

        multipleStylesTitle: 'Presis redigering på naturlig språk',
        multipleStylesDesc:
            'Rediger deler av et eksisterende bilde med enkle instrukser—uten kompleks maskering. Si “erstatt kaffen på bordet med en dampende kopp grønn te”, og modellen vil bytte objektet og automatisk justere lys og refleksjoner rundt, mens alt annet forblir uendret.',
        multipleStylesAlt: 'Eksempel på presis redigering på naturlig språk',

        preciseTextTitle: 'Perfekt layout og tekstrendering',
        preciseTextDesc:
            'Si farvel til stavefeil og rotete tekst i AI-bilder. GPT Image 1.5 kan rendere lange tekster tydelig, i varierte stiler, med korrekt stavemåte—ideelt for plakater, bokomslag, UI-mockups og infografikk-lignende visuals med diagrammer.',
        preciseTextAlt: 'Eksempel på perfekt layout og tekstrendering',

        interactiveEditingTitle: 'Konsistens i karakter og stil',
        interactiveEditingDesc:
            'Når du genererer en serie bilder, kan modellen “huske” spesifikke karaktertrekk (hår, antrekk, ansiktstrekk) eller en bestemt kunststil. Dette gjør det enkelt å lage tegneserier, storyboards eller merkevarekonsistente markedsføringsressurser.',
        interactiveEditingAlt: 'Eksempel på konsistens i karakter og stil',

        // How to Use Section
        howToUseTitle: 'Slik bruker du GPT Image 1.5 på WeryAI',
        howToUseSubtitle: 'Kom i gang i tre enkle trinn',

        step1Title: 'Velg modellen',
        step1Description: 'Velg GPT Image 1.5-modellen i AI-bildemodeller',

        step2Title: 'Skriv inn innhold',
        step2Description: 'Skriv inn en prompt eller last opp et referansebilde',

        step3Title: 'Generer bilder',
        step3Description:
            'Klikk på generer-knappen, vent og last ned bildene dine',

        // YouTube Videos Section
        youtubeTitle: 'YouTube-videoer om GPT Image 1.5-bildemodellen',

        // X Posts Section
        xPostsTitle: 'X-innlegg om GPT Image 1.5-bildemodellen',

        // Explore Other Models Section
        exploreModelsTitle: 'Utforsk andre AI-bildemodeller på WeryAI',
        model1Title: 'Google Nano Banana Pro',
        model2Title: 'Seedream 4.5',
        model3Title: 'Qwen Image',
        model4Title: 'Dreamina 4.0',

        // FAQ Section
        faqTitle: 'Ofte stilte spørsmål',
        faq1Question:
            'Hva er forskjellen mellom GPT Image 1.5 og DALL·E 3?',
        faq1Answer:
            'GPT Image 1.5 er etterfølgeren til DALL·E 3. De viktigste forskjellene er sterkere “verdensforståelse” for mer logiske resultater, presis lokal redigering og pålitelig tekstrendering—og den er opptil 4× raskere.',

        faq2Question: 'Kan den generere nøyaktig tekst?',
        faq2Answer:
            'Ja—dette er et stort høydepunkt ved GPT Image 1.5. Enten det er engelske titler, slagord eller kodebiter, render den tekst med svært høy nøyaktighet og eliminerer i stor grad den gamle “AI-gibberish”.',

        faq3Question: 'Må jeg betale for å bruke den på WeryAI?',
        faq3Answer:
            'Ja. WeryAI tilbyr en gratis prøvekvote. Siden GPT Image 1.5 er en høyytelsesmodell, kan generering av HD-bilder eller flertrinnsredigering bruke flere kreditter. Tunge brukere bør vurdere å oppgradere til Pro-planen.',

        faq4Question: 'Kan jeg laste opp egne bilder for å redigere?',
        faq4Answer:
            'Ja. Du kan bruke “image-to-image” eller “edit”-modus for å laste opp et eksisterende bilde, og deretter bruke tekstinstruksjoner for å få GPT Image 1.5 til å endre det (f.eks. bytte antrekk eller bakgrunner).',

        faq5Question: 'Hvor viser resonneringen seg?',
        faq5Answer:
            'I måten den forstår implisitte detaljer. For eksempel, hvis du skriver “et nerderom fra 80-tallet”, vil modellen automatisk legge til tidsriktige detaljer som en CRT-skjerm, retroplakater og rotete kabler—uten at du må liste dem én for én.',

        faq6Question: 'Hvem eier de kommersielle rettighetene?',
        faq6Answer:
            'I henhold til OpenAI- og WeryAI-retningslinjer tilhører bildene du genererer med GPT Image 1.5 deg, og du kan bruke dem kommersielt (f.eks. annonser og produktemballasje).',

        // CTA Section
        ctaTitle: 'Klar til å skape?',
        ctaDescription:
            'Prøv GPT Image 1.5 nå og gjør ideene dine om til fantastiske bilder',
        ctaButton: 'Prøv GPT Image 1.5 nå',
        ctaDisclaimer: 'Ingen kredittkort kreves — registrer deg og kom i gang',
        },
    nl: {
        // SEO Meta
        pageTitle:
            'GPT Image 1.5 AI-beeldgenerator - Geavanceerd DALL·E 3-alternatief',
        pageDescription:
            'Als krachtige upgrade van OpenAI’s DALL·E 3 begrijpt GPT Image 1.5 complexe ideeën nauwkeuriger en kun je beelden direct in de chat creëren en bewerken via vloeiende conversaties. Probeer de nieuwste GPT Image 1.5 vandaag gratis op WeryAI.',
        pageKeywords:
            'GPT Image 1.5, OpenAI, AI-beeldgenerator, AI-kunst, kunstmatige intelligentie, beeldbewerking, DALL·E-alternatief, conversationele AI',

        // Open Graph
        ogTitle:
            'GPT Image 1.5 AI-beeldgenerator - Geavanceerd DALL·E 3-alternatief',
        ogDescription:
            'Een krachtige upgrade van OpenAI’s DALL·E 3, GPT Image 1.5 begrijpt je ideeën precies via natuurlijke conversatie.',

        // Twitter Card
        twitterTitle:
            'GPT Image 1.5 AI-beeldgenerator - Geavanceerd DALL·E 3-alternatief',
        twitterDescription:
            'Een grote upgrade van OpenAI’s DALL·E 3 — GPT Image 1.5 begrijpt complexe ideeën via chat-gebaseerde bewerking. Probeer gratis!',

        // Generator Section
        generatorTitle: 'GPT Image 1.5 beeldgenerator',
        generatorSubtitle:
            'WeryAI heeft het model GPT Image 1.5 nu diep geïntegreerd, GPT Image 1.5 is OpenAI’s nieuwste vlaggenschipmodel voor beeldgeneratie en het eerste vision-model met het “GPT”-merk, waarmee het een duidelijke stap voorbij het DALL·E-tijdperk markeert. Gelanceerd in december 2025 gaat het verder dan eenvoudige “tekst-naar-pixel”-matching en gebruikt het GPT-5-niveau redenering om fysica, causaliteit en genuanceerde culturele context te begrijpen. GPT Image 1.5 is tot 4× sneller dan de vorige generatie en introduceert revolutionaire “conversationele bewerking”, waarmee je beelddetails kunt verfijnen alsof je een document bewerkt—terwijl het eindelijk het hardnekkige probleem van verminkte AI-tekst oplost. Probeer GPT Image 1.5 gratis op WeryAI en ervaar een AI-maker die niet alleen tekent—maar je begrijpt.',

        // Core Features Section
        coreFeaturesTitle: 'Kernfuncties van GPT Image 1.5',
        coreFeaturesSubtitle:
            'Ontdek de kernmogelijkheden van de GPT Image 1.5 AI-beeldgenerator en begin aan een revolutionaire creatieve reis',

        // Features
        highFidelityTitle: 'Wereldlogisch redeneren',
        highFidelityDesc:
            'In tegenstelling tot traditionele modellen die scènes aan elkaar plakken met trefwoorden, begrijpt GPT Image 1.5 de fysica en logica van de echte wereld. Vanuit korte prompts kan het correcte belichting en reflecties, zwaartekracht en objecttoestanden afleiden, evenals historisch accurate details (bijv. “een muziekfestival uit 1969” past bij kleding en sfeer van die tijd).',
        highFidelityAlt: 'Voorbeeld van wereldlogisch redeneren',

        multipleStylesTitle: 'Nauwkeurige bewerking in natuurlijke taal',
        multipleStylesDesc:
            'Bewerk delen van een bestaand beeld met eenvoudige instructies—geen complexe maskering nodig. Zeg “vervang de koffie op tafel door een dampende kop groene thee”, en het model wisselt het object en past automatisch het omringende licht en de reflecties aan, terwijl de rest onveranderd blijft.',
        multipleStylesAlt: 'Voorbeeld van nauwkeurige bewerking in natuurlijke taal',

        preciseTextTitle: 'Perfecte lay-out en tekstrendering',
        preciseTextDesc:
            'Zeg vaarwel tegen spelfouten en verminkte tekst in AI-beelden. GPT Image 1.5 kan lange teksten helder renderen, in diverse stijlen, met correcte spelling—ideaal voor posters, boekomslagen, UI-mockups en infographic-achtige visuals met grafieken.',
        preciseTextAlt: 'Voorbeeld van perfecte lay-out en tekstrendering',

        interactiveEditingTitle: 'Consistentie van karakter en stijl',
        interactiveEditingDesc:
            'Bij het genereren van een reeks beelden kan het model specifieke karaktereigenschappen (haar, outfits, gelaatstrekken) of een bepaalde kunststijl “onthouden”. Dit maakt het eenvoudig om strips, storyboards of merkconsistente marketingmiddelen te maken.',
        interactiveEditingAlt: 'Voorbeeld van consistentie van karakter en stijl',

        // How to Use Section
        howToUseTitle: 'Hoe je GPT Image 1.5 op WeryAI gebruikt',
        howToUseSubtitle: 'Begin in drie eenvoudige stappen',

        step1Title: 'Kies het model',
        step1Description: 'Selecteer het GPT Image 1.5-model in AI-beeldmodellen',

        step2Title: 'Voer inhoud in',
        step2Description: 'Typ een prompt of upload een referentiebeeld',

        step3Title: 'Genereer beelden',
        step3Description:
            'Klik op de genereerknop, wacht en download je beelden',

        // YouTube Videos Section
        youtubeTitle: 'YouTube-video\'s over het GPT Image 1.5-beeldmodel',

        // X Posts Section
        xPostsTitle: 'X-posts over het GPT Image 1.5-beeldmodel',

        // Explore Other Models Section
        exploreModelsTitle: 'Ontdek andere AI-beeldmodellen op WeryAI',
        model1Title: 'Google Nano Banana Pro',
        model2Title: 'Seedream 4.5',
        model3Title: 'Qwen Image',
        model4Title: 'Dreamina 4.0',

        // FAQ Section
        faqTitle: 'Veelgestelde vragen',
        faq1Question:
            'Wat is het verschil tussen GPT Image 1.5 en DALL·E 3?',
        faq1Answer:
            'GPT Image 1.5 is de opvolger van DALL·E 3. De belangrijkste verschillen zijn een sterkere “wereldbegrip” voor logischere output, nauwkeurige lokale bewerking en betrouwbare tekstrendering—plus het is tot 4× sneller.',

        faq2Question: 'Kan het nauwkeurige tekst genereren?',
        faq2Answer:
            'Ja—dit is een belangrijk hoogtepunt van GPT Image 1.5. Of het nu Engelse titels, slogans of codefragmenten zijn, het renderen van tekst is zeer nauwkeurig en elimineert grotendeels het oude “AI-geklets”.',

        faq3Question: 'Moet ik betalen om het op WeryAI te gebruiken?',
        faq3Answer:
            'Ja. WeryAI biedt een gratis proefquotum. Omdat GPT Image 1.5 een high-performance model is, kunnen HD-beelden of meerstapsbewerking meer credits verbruiken. Zware gebruikers willen mogelijk upgraden naar het Pro-abonnement.',

        faq4Question: 'Kan ik mijn eigen beelden uploaden om te bewerken?',
        faq4Answer:
            'Ja. Je kunt de “image-to-image” of “edit”-modus gebruiken om een bestaande foto te uploaden en vervolgens tekstinstructies gebruiken om GPT Image 1.5 deze te laten aanpassen (bijv. outfits of achtergronden wijzigen).',

        faq5Question: 'Waar komt het redeneren tot uiting?',
        faq5Answer:
            'In hoe het impliciete details begrijpt. Als je bijvoorbeeld “een nerdkamer uit de jaren 80” typt, voegt het model automatisch tijdgebonden details toe zoals een CRT-monitor, retro posters en rommelige kabels—zonder dat je ze één voor één hoeft te noemen.',

        faq6Question: 'Wie bezit de commerciële rechten?',
        faq6Answer:
            'Volgens het beleid van OpenAI en WeryAI zijn de beelden die je met GPT Image 1.5 genereert van jou, en kun je ze commercieel gebruiken (bijv. advertenties, productverpakkingen).',

        // CTA Section
        ctaTitle: 'Klaar om te creëren?',
        ctaDescription:
            'Probeer GPT Image 1.5 nu en zet je ideeën om in verbluffende beelden',
        ctaButton: 'Probeer GPT Image 1.5 nu',
        ctaDisclaimer: 'Geen creditcard nodig — meld je aan om te beginnen',
        },
    id: {
        // SEO Meta
        pageTitle:
            'Generator Gambar AI GPT Image 1.5 - Alternatif DALL·E 3 Lanjutan',
        pageDescription:
            'Sebagai peningkatan kuat dari OpenAI DALL·E 3, GPT Image 1.5 memahami ide kompleks secara lebih presisi dan memungkinkan Anda membuat serta mengedit gambar langsung di chat melalui interaksi percakapan yang mulus. Coba GPT Image 1.5 terbaru di WeryAI gratis hari ini.',
        pageKeywords:
            'GPT Image 1.5, OpenAI, generator gambar AI, seni AI, kecerdasan buatan, pengeditan gambar, alternatif DALL·E, AI percakapan',

        // Open Graph
        ogTitle:
            'Generator Gambar AI GPT Image 1.5 - Alternatif DALL·E 3 Lanjutan',
        ogDescription:
            'Peningkatan kuat dari OpenAI DALL·E 3, GPT Image 1.5 memahami ide Anda secara presisi melalui interaksi percakapan alami.',

        // Twitter Card
        twitterTitle:
            'Generator Gambar AI GPT Image 1.5 - Alternatif DALL·E 3 Lanjutan',
        twitterDescription:
            'Peningkatan besar dari OpenAI DALL·E 3 — GPT Image 1.5 memahami ide kompleks lewat pengeditan berbasis chat. Coba gratis!',

        // Generator Section
        generatorTitle: 'Generator Gambar GPT Image 1.5',
        generatorSubtitle:
            'WeryAI kini telah mengintegrasikan model GPT Image 1.5 secara mendalam, GPT Image 1.5 adalah model generasi gambar flagship terbaru dari OpenAI dan model visi pertama yang memakai merek “GPT”, menandai langkah tegas melampaui era DALL·E. Dirilis pada Desember 2025, ia melampaui pencocokan “teks-ke-piksel” sederhana dan memanfaatkan penalaran setingkat GPT-5 untuk memahami fisika, kausalitas, dan konteks budaya yang bernuansa. GPT Image 1.5 hingga 4× lebih cepat dari generasi sebelumnya dan memperkenalkan “pengeditan percakapan” yang revolusioner, memungkinkan Anda menyempurnakan detail gambar seperti mengedit dokumen—sekaligus akhirnya memecahkan masalah lama teks AI yang kacau. Coba GPT Image 1.5 di WeryAI gratis dan rasakan kreator AI yang tidak sekadar menggambar—ia memahami Anda.',

        // Core Features Section
        coreFeaturesTitle: 'Fitur inti GPT Image 1.5',
        coreFeaturesSubtitle:
            'Jelajahi kemampuan inti generator gambar AI GPT Image 1.5 dan mulai perjalanan kreatif yang revolusioner',

        // Features
        highFidelityTitle: 'Penalaran logika dunia',
        highFidelityDesc:
            'Berbeda dari model tradisional yang menjahit adegan dari kata kunci, GPT Image 1.5 memahami fisika dan logika dunia nyata. Dari prompt singkat, ia dapat menyimpulkan pencahayaan dan pantulan yang benar, gravitasi dan keadaan objek, serta detail historis yang akurat (misalnya “festival musik tahun 1969” akan cocok dengan pakaian dan atmosfer pada masa itu).',
        highFidelityAlt: 'Contoh penalaran logika dunia',

        multipleStylesTitle: 'Pengeditan bahasa alami yang presisi',
        multipleStylesDesc:
            'Edit bagian dari gambar yang ada dengan instruksi sederhana—tanpa masking kompleks. Katakan “ganti kopi di meja dengan secangkir teh hijau panas”, dan model akan mengganti objek serta menyesuaikan cahaya dan pantulan di sekitarnya secara otomatis sementara bagian lain tetap sama.',
        multipleStylesAlt: 'Contoh pengeditan bahasa alami yang presisi',

        preciseTextTitle: 'Tata letak sempurna & perenderan teks',
        preciseTextDesc:
            'Ucapkan selamat tinggal pada salah eja dan teks kacau di gambar AI. GPT Image 1.5 dapat merender teks panjang dengan jelas, dalam berbagai gaya, dengan ejaan akurat—ideal untuk poster, sampul buku, mockup UI, dan visual bergaya infografik dengan grafik.',
        preciseTextAlt: 'Contoh tata letak sempurna dan perenderan teks',

        interactiveEditingTitle: 'Konsistensi karakter & gaya',
        interactiveEditingDesc:
            'Saat menghasilkan serangkaian gambar, model dapat “mengingat” ciri karakter tertentu (rambut, pakaian, fitur wajah) atau gaya seni tertentu. Ini memudahkan pembuatan komik, storyboard, atau aset pemasaran yang konsisten dengan merek.',
        interactiveEditingAlt: 'Contoh konsistensi karakter dan gaya',

        // How to Use Section
        howToUseTitle: 'Cara menggunakan GPT Image 1.5 di WeryAI',
        howToUseSubtitle: 'Mulai berkarya dalam tiga langkah sederhana',

        step1Title: 'Pilih model',
        step1Description: 'Pilih model GPT Image 1.5 di model gambar AI',

        step2Title: 'Masukkan konten',
        step2Description: 'Ketik prompt atau unggah gambar referensi',

        step3Title: 'Hasilkan gambar',
        step3Description:
            'Klik tombol generate, lalu tunggu dan unduh gambar Anda',

        // YouTube Videos Section
        youtubeTitle: 'Video YouTube tentang model gambar GPT Image 1.5',

        // X Posts Section
        xPostsTitle: 'Postingan X tentang model gambar GPT Image 1.5',

        // Explore Other Models Section
        exploreModelsTitle: 'Jelajahi model gambar AI lainnya di WeryAI',
        model1Title: 'Google Nano Banana Pro',
        model2Title: 'Seedream 4.5',
        model3Title: 'Qwen Image',
        model4Title: 'Dreamina 4.0',

        // FAQ Section
        faqTitle: 'Pertanyaan yang sering diajukan',
        faq1Question:
            'Apa perbedaan antara GPT Image 1.5 dan DALL·E 3?',
        faq1Answer:
            'GPT Image 1.5 adalah penerus DALL·E 3. Perbedaan utamanya adalah “pemahaman dunia” yang lebih kuat untuk keluaran yang lebih logis, pengeditan lokal yang presisi, dan perenderan teks yang andal—plus hingga 4× lebih cepat.',

        faq2Question: 'Apakah bisa menghasilkan teks yang akurat?',
        faq2Answer:
            'Ya—ini adalah sorotan utama GPT Image 1.5. Baik judul bahasa Inggris, slogan, atau potongan kode, ia merender teks dengan akurasi sangat tinggi dan sebagian besar menghilangkan “omong kosong AI” lama.',

        faq3Question: 'Apakah saya perlu membayar untuk menggunakannya di WeryAI?',
        faq3Answer:
            'Ya. WeryAI menawarkan kuota uji coba gratis. Karena GPT Image 1.5 adalah model berperforma tinggi, pembuatan gambar HD atau pengeditan multi-langkah dapat menghabiskan lebih banyak kredit. Pengguna berat mungkin ingin upgrade ke paket Pro.',

        faq4Question: 'Bisakah saya mengunggah gambar sendiri untuk diedit?',
        faq4Answer:
            'Ya. Anda dapat menggunakan mode “image-to-image” atau “edit” untuk mengunggah foto yang ada, lalu gunakan instruksi teks agar GPT Image 1.5 memodifikasinya (misalnya mengganti pakaian atau latar).',

        faq5Question: 'Di mana penalarannya terlihat?',
        faq5Answer:
            'Pada cara memahami detail yang tersirat. Misalnya, jika Anda mengetik “ruang geek era 80-an”, model akan otomatis menambahkan detail sesuai era seperti monitor CRT, poster retro, dan kabel berantakan—tanpa Anda perlu menyebutkannya satu per satu.',

        faq6Question: 'Siapa yang memiliki hak komersial?',
        faq6Answer:
            'Menurut kebijakan OpenAI dan WeryAI, gambar yang Anda hasilkan dengan GPT Image 1.5 adalah milik Anda, dan dapat digunakan secara komersial (misalnya iklan, kemasan produk).',

        // CTA Section
        ctaTitle: 'Siap mulai berkarya?',
        ctaDescription:
            'Coba GPT Image 1.5 sekarang dan ubah ide Anda menjadi gambar yang menakjubkan',
        ctaButton: 'Coba GPT Image 1.5 sekarang',
        ctaDisclaimer: 'Tidak perlu kartu kredit — daftar untuk mulai',
        },
    tr: {
        // SEO Meta
        pageTitle:
            'GPT Image 1.5 AI Görsel Üretici - Gelişmiş DALL·E 3 Alternatifi',
        pageDescription:
            'OpenAI’nin DALL·E 3 modeline güçlü bir yükseltme olarak GPT Image 1.5, karmaşık fikirleri daha hassas anlar ve akıcı sohbet etkileşimleriyle görüntüleri doğrudan sohbet içinde oluşturup düzenlemenizi sağlar. En yeni GPT Image 1.5’i WeryAI’de bugün ücretsiz deneyin.',
        pageKeywords:
            'GPT Image 1.5, OpenAI, AI görsel üretici, AI sanatı, yapay zeka, görsel düzenleme, DALL·E alternatifi, sohbet tabanlı AI',

        // Open Graph
        ogTitle:
            'GPT Image 1.5 AI Görsel Üretici - Gelişmiş DALL·E 3 Alternatifi',
        ogDescription:
            'OpenAI’nin DALL·E 3 modeline güçlü bir yükseltme olarak GPT Image 1.5, doğal sohbet etkileşimiyle fikirlerinizi hassas biçimde anlar.',

        // Twitter Card
        twitterTitle:
            'GPT Image 1.5 AI Görsel Üretici - Gelişmiş DALL·E 3 Alternatifi',
        twitterDescription:
            'OpenAI’nin DALL·E 3’üne büyük bir yükseltme — GPT Image 1.5, sohbet tabanlı düzenleme ile karmaşık fikirleri anlar. Ücretsiz deneyin!',

        // Generator Section
        generatorTitle: 'GPT Image 1.5 Görsel Üretici',
        generatorSubtitle:
            'WeryAI artık GPT Image 1.5 modelini derinlemesine entegre ediyor, GPT Image 1.5, OpenAI’nin en yeni amiral gemisi görsel üretim modeli ve “GPT” markasını taşıyan ilk görsel modelidir; bu da DALL·E döneminin ötesine kesin bir adım anlamına gelir. Aralık 2025’te yayınlanan model, basit “metinden piksele” eşleştirmeyi geride bırakır ve bunun yerine GPT-5 düzeyinde akıl yürütme ile fizik, nedensellik ve nüanslı kültürel bağlamı anlar. GPT Image 1.5 önceki nesle göre 4× daha hızlıdır ve devrim niteliğindeki “sohbet tabanlı düzenlemeyi” sunar; görüntü ayrıntılarını bir belgeyi düzenler gibi ince ayar yapmanıza olanak tanır—ve nihayet bozuk AI metni sorununu çözer. GPT Image 1.5’i WeryAI’de ücretsiz deneyin ve sadece çizmekle kalmayıp sizi anlayan bir AI yaratıcıyı deneyimleyin.',

        // Core Features Section
        coreFeaturesTitle: 'GPT Image 1.5 Temel Özellikleri',
        coreFeaturesSubtitle:
            'GPT Image 1.5 AI görsel üreticisinin temel yeteneklerini keşfedin ve devrim niteliğinde bir yaratıcı yolculuğa başlayın',

        // Features
        highFidelityTitle: 'Dünya mantığına dayalı muhakeme',
        highFidelityDesc:
            'Anahtar kelimelerle sahneleri birleştiren geleneksel modellerden farklı olarak GPT Image 1.5 gerçek dünyanın fizik ve mantığını anlar. Kısa istemlerden doğru aydınlatma ve yansımaları, yerçekimi ve nesne durumlarını, ayrıca tarihsel olarak doğru ayrıntıları çıkarabilir (ör. “1969 müzik festivali” döneme uygun kıyafet ve atmosferle eşleşir).',
        highFidelityAlt: 'Dünya mantığına dayalı muhakeme örneği',

        multipleStylesTitle: 'Doğal dilde hassas düzenleme',
        multipleStylesDesc:
            'Mevcut bir görselin bölümlerini basit talimatlarla düzenleyin—karmaşık maskeleme gerekmez. “Masadaki kahveyi buharlı bir yeşil çayla değiştir” dediğinizde model nesneyi değiştirir ve çevredeki ışık ile yansımaları otomatik ayarlarken diğer her şeyi olduğu gibi bırakır.',
        multipleStylesAlt: 'Doğal dilde hassas düzenleme örneği',

        preciseTextTitle: 'Mükemmel düzen ve metin işleme',
        preciseTextDesc:
            'AI görsellerdeki yazım hataları ve bozuk metinlere veda edin. GPT Image 1.5, uzun metinleri farklı stillerde net biçimde ve doğru yazımla işleyebilir—posterler, kitap kapakları, UI maketleri ve grafik içeren infografik tarzı görseller için idealdir.',
        preciseTextAlt: 'Mükemmel düzen ve metin işleme örneği',

        interactiveEditingTitle: 'Karakter ve stil tutarlılığı',
        interactiveEditingDesc:
            'Bir dizi görsel üretirken model belirli karakter özelliklerini (saç, kıyafet, yüz özellikleri) veya belirli bir sanat stilini “hatırlayabilir”. Bu, çizgi roman, storyboard veya markayla uyumlu pazarlama varlıkları oluşturmayı kolaylaştırır.',
        interactiveEditingAlt: 'Karakter ve stil tutarlılığı örneği',

        // How to Use Section
        howToUseTitle: 'WeryAI’de GPT Image 1.5 nasıl kullanılır',
        howToUseSubtitle: 'Üç basit adımda oluşturmaya başlayın',

        step1Title: 'Modeli seçin',
        step1Description: 'AI görsel modellerinde GPT Image 1.5 modelini seçin',

        step2Title: 'İçerik girin',
        step2Description: 'Bir istem yazın veya referans görsel yükleyin',

        step3Title: 'Görselleri oluşturun',
        step3Description:
            'Oluştur düğmesine tıklayın, bekleyin ve görsellerinizi indirin',

        // YouTube Videos Section
        youtubeTitle: 'GPT Image 1.5 görsel modeli hakkında YouTube videoları',

        // X Posts Section
        xPostsTitle: 'GPT Image 1.5 görsel modeli hakkında X gönderileri',

        // Explore Other Models Section
        exploreModelsTitle: 'WeryAI’de diğer AI görsel modellerini keşfedin',
        model1Title: 'Google Nano Banana Pro',
        model2Title: 'Seedream 4.5',
        model3Title: 'Qwen Image',
        model4Title: 'Dreamina 4.0',

        // FAQ Section
        faqTitle: 'Sıkça sorulan sorular',
        faq1Question:
            'GPT Image 1.5 ile DALL·E 3 arasındaki fark nedir?',
        faq1Answer:
            'GPT Image 1.5, DALL·E 3’ün halefidir. Temel farklar; daha mantıklı çıktılar için daha güçlü “dünya anlayışı”, hassas yerel düzenleme ve güvenilir metin işleme—artı 4× daha hızlı olmasıdır.',

        faq2Question: 'Doğru metin üretebilir mi?',
        faq2Answer:
            'Evet—bu GPT Image 1.5’in en büyük öne çıkan özelliklerinden biridir. İster İngilizce başlıklar, sloganlar veya kod parçacıkları olsun, metni çok yüksek doğrulukla işler ve eski “AI saçmalığı” sorununu büyük ölçüde ortadan kaldırır.',

        faq3Question: 'WeryAI’de kullanmak için ödeme yapmam gerekir mi?',
        faq3Answer:
            'Evet. WeryAI ücretsiz deneme kotası sunar. GPT Image 1.5 yüksek performanslı bir model olduğundan, HD görsel üretimi veya çok adımlı düzenlemeler daha fazla kredi tüketebilir. Yoğun kullanıcılar Pro plana yükseltmeyi düşünebilir.',

        faq4Question: 'Kendi görsellerimi düzenlemek için yükleyebilir miyim?',
        faq4Answer:
            'Evet. Mevcut bir fotoğrafı yüklemek için “image-to-image” veya “edit” modunu kullanabilir, ardından GPT Image 1.5’in metin talimatlarıyla görseli değiştirmesini sağlayabilirsiniz (örn. kıyafet veya arka plan değişikliği).',

        faq5Question: 'Muhakemesi nerede ortaya çıkar?',
        faq5Answer:
            'Örtük ayrıntıları nasıl anladığında. Örneğin “80’lerden bir geek odası” yazarsanız model, CRT monitör, retro posterler ve dağınık kablolar gibi döneme uygun ayrıntıları siz tek tek saymadan otomatik ekler.',

        faq6Question: 'Ticari haklar kime ait?',
        faq6Answer:
            'OpenAI ve WeryAI politikalarına göre GPT Image 1.5 ile ürettiğiniz görseller size aittir ve ticari olarak kullanabilirsiniz (örn. reklamlar, ürün ambalajları).',

        // CTA Section
        ctaTitle: 'Oluşturmaya hazır mısınız?',
        ctaDescription:
            'GPT Image 1.5’i şimdi deneyin ve fikirlerinizi büyüleyici görsellere dönüştürün',
        ctaButton: 'GPT Image 1.5’i şimdi deneyin',
        ctaDisclaimer: 'Kredi kartı gerekmez — kaydolup başlayın',
    },
}
